import React, {forwardRef, memo, useCallback, useEffect, useImperativeHandle, useRef, useState} from "react";
import {
    batchUpdateProperties,
    batchUpdateViews,
    dbGetHighlight, dbGetHighlightByLibraryId,
    deleteAllCardFromRefProject, delNote, editDoc, getBoardByTagName, getCardById,
    getCardByTagName, getCardDoc, getNoteById, getNoteJsonDoc, getNoteList,
    getProjectByTagName, getPropertyList, getSortPropertyList, getViewList, renameCard, staticTagsInColumn,
    updateCard, updateChangeSource, updateHighlight, updateNote, updateProject, updateView
} from "../../../model";
import {Dropdown, Empty, Input, Select, Spin, message, Popover, Tag, Button, Checkbox,Tooltip} from "antd";
import {
    DEFAULT_TAG_BACKGROUND_COLOR,
    EVENT_FAVIRIATE_CHANGE,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_RECENTS,
    EVENT_REFRESH_TAG_LSIT,
    EVENT_RENAME_LIBRARY_ITEM,
    FILTER_PROJECT_ID_ALL,
    FILTER_PROJECT_ID_ALL_0,
    FILTER_PROJECT_ID_ALL_IN_PROJECT,
    FILTER_PROJECT_ID_NOT_IN_PROJECT_ALL, FROM_DIALOG, FROM_HOME_LIBRARY,
    FROM_LIBRARY,
    FROM_TAG,
    FROM_TRASH,
    getDefaultTagBackgroundColor, getPropertySelectOptionBackgroundColor,
    KEY_FILE_DIR,
    KEY_PROPERTY_LIST_STATUS,
    KEY_SHOW_HIDIN_CARDS,
    KEY_TAGITEM_ORDER_BY,
    KEY_TAGITEM_SORT_TYPE,
    SEARCH_WIDTH, TITLE_BAR_HEIGHT,
    VIEW_STYLE, WIDTH_3, WIDTH_4, WIDTH_5
} from "../../Const";
import CardItem from "../Library/CardItem";
import {
    createCopyLinkByLibraryItem,
    decodeDeeplink, filterNumericInput,
    formatDateCharDesc,
    generateUUID2,
    getAudioFilterExt,
    getFileNameExt,
    getImagePath,
    getImagePathSvg,
    getImagePathWithTheme,
    getImagePathWithThemeSvg,
    getItem,
    imgPathPerfix,
    isArray,
    isDarkMode,
    isDeepLink, isNumber,
    isNumberOrFloat,
    isStringNullOrEmpty
} from "../../utils";
import {t} from "i18next";
import Note from "@/views/Note/NoteItem/NoteItemIndex";
import DialogTagManager from "@/views/Dialog/DialogTagManager";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import Global from "@/global";
import {openEditor} from "@/state";
import DialogMessageBox from "@/common/DialogMessageBox";
import DialogCommonInput from "@/common/DialogCommonInput";
import {useEditor} from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import {Import} from "@tiptap-pro/extension-import";
import {Export} from "@tiptap-pro/extension-export";
import Text from "@tiptap/extension-text";
import TextStyle from "@tiptap/extension-text-style";
import {Color} from "@tiptap/extension-color";
import Heading from "@tiptap/extension-heading";
import Paragraph from "@tiptap/extension-paragraph";
import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import Placeholder from "@tiptap/extension-placeholder";
import FontSize from "tiptap-extension-font-size";
import {Indent} from "@/components/EditorV2/indent";
import Link from "@/components/EditorV2/extension-link/src";
import ImageT from "@tiptap/extension-image";
import Image from "@/components/EditorV2/imgResize";
import {Hyperlink} from "@docs.plus/extension-hyperlink";
import TaskList from "@tiptap/extension-task-list";
import TaskItem from "@tiptap/extension-task-item";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Blockquote from "@tiptap/extension-blockquote";
import {FontFamily} from "@tiptap/extension-font-family";
import {isWeb} from "@/electron_interactive";
import DialogChooseThumb from "@/views/Home/DialogChooseThumb";
import {noteServer} from "@/common/notesServer";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import clipboard from "clipboardy";
import {CheckOutlined} from "@ant-design/icons";
import UniqueID from "@tiptap-pro/extension-unique-id";
import {debugLog} from "@/LogUtils";
import {IconDropdownSelected, IconMenuChecked1, IconSearchPdfCard} from "@/Icon";
import { saveAs } from 'file-saver';
import JSZip from "jszip";
import {getSearchWidth, isMac} from "@/Utility";
import TableView from "@/views/Property/TableView";
import PopupDate from "@/views/Property/PopupDate";
import DialogBatchUpdateProperty from "@/views/Property/DialogBatchUpdateProperty";
import global from "@/global";
import {Grid} from 'react-virtualized';
import {useAtom} from "jotai";
import {atomHomeLeftMenu, atomHomePaddingLeft, atomIsDragLine} from "@/views/Home/HomeIndex";
import {getFilterOperator} from "@/UtilityInner";
import {DndContext, DragEndEvent} from "@dnd-kit/core";
import {
    arrayMove,
    horizontalListSortingStrategy,
    SortableContext,
    useSortable,
} from '@dnd-kit/sortable';
import BoardItem from "@/views/Note/BoardItem";
import {useLocation} from "react-use";
import HomeNavigator from "@/views/Home/HomeNavigator";
import {atomSliderWidth} from "@/App";

let mMapIdCheck:any={};
// 是否需要(允许)处理鼠标的移动事件,默认识不处理
var select = false;
// 定义移动元素div
var rect:any = null;
// 记录鼠标按下时的坐标
var downX = 0;
var downY = 0;
// 记录鼠标抬起时候的坐标
var mouseX2=downX;
var mouseY2=downY;
var mMouseDownTime:any = 0;
let mHandleTime = 0;
let mArrayTypes:any,mszProjectId:any,mszTag:any,mszSearchKey:any;
let mSortTypeDesc = "Last viewed";
//为什么使用这个，不使用引用。因为不知道card界面按  keys.escapse从哪个临时的东西过来的。重新生成就是比较恶心的逻辑.
let mArrayOriginSort:any = null;

const TagItemList = forwardRef((props:{tagName:string,onBackCallback:any,onCancelCallback:any,onSelectCallback:any,from:any,onRefreshDataFinished:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onRefresh:(arrayTypes:any,szProjectId:any,szTag:any,szSearchKey:any)=>{
            refreshDataWithFilter(arrayTypes,szProjectId,szTag,szSearchKey);
        },
        onSetSelectEvent:(szStr:string)=>{
            setOperButtonName(szStr);
            if (szStr == t("Select")) {
                //当前是选择状态，点击取消
                // setOperButtonName(t("Cancel"));
                var arrayNew = [...arrayDatas];
                arrayNew.forEach(p=>{
                    delete p.isChecked;
                })
                setArrayDatas(arrayNew);

            } else {
                // setOperButtonName(t("Select"));
            }
            setIsShowChecked(!isShowChecked);
        }
    }))
    const [arrayDatas,setArrayDatas] = useState([]);
    const [operButtonName,setOperButtonName] = useState(t("Select"));
    const [isShowChecked,setIsShowChecked] = useState(false);
    const [checkItemCount,setCheckItemCount] = useState(0);
    const [sortMenuOpen, setSortMenuOpen] = useState(false);
    const [sortTypeDesc,setSortTypeDesc] = useState(mSortTypeDesc);
    const [gridColumns,setGridColumns] = useState('repeat(4,1fr)');
    const [exportValue,setExportValue] = useState(t('Export'))
    const [arrayViews,setArrayViews] = useState([]);
    const [searchKey,setSearchKey] = useState('');
    const [searchProperty,setSearchProperty] = useState<any>('');
    const [selectView,setSelectView] = useState<any>(null);
    const [selectViewColumn,setSelectViewColumn] = useState([])
    const [arrayPropertys,setArrayPropertys] = useState([]);//属性列表
    const [isSearching,setIsSearching] = useState(false);
    const [isAddPropertyOpen,setIsAddPropertyOpen] = useState(false);
    const [isFilterSomeOpen,setIsFilterSomeOpen] = useState<any>({});
    const [isFilterOpen,setIsFilterOpen] = useState(false);
    const [mapFilterDropdownOpen,setMapFilterDropdownOpen] = useState<any>({})
    const [randomUUID,setRandomUUID] = useState<any>({});
    const [filterCount,setFilterCount] = useState(0);
    const [rowSelectCount,setRowSelectCount] = useState(0);
    const [propertyListStatus,setPropertyListStatus] = useState<any>({'default':true,'custom':true})
    const [mapColumnInTags,setMapColumnInTags] = useState<any>({});
    const [cardItemSize,setCardItemSize] = useState({width:0,height:0});
    const [homeLeftWidth,setHomeLeftWidth] = useAtom(atomHomePaddingLeft);
    const [rightSliderWidth,setRightSliderWidth] = useAtom(atomSliderWidth);
    const [isDragLine,setIsDragLine] = useAtom(atomIsDragLine);

    const dialogTagManagerRef = useRef(null);
    const dialogMessageRef = useRef(null);
    const dialogCommonInputRef = useRef(null);
    const dialogChooseThumbRef = useRef(null);
    const dialogBatchUpdatePropertyRef = useRef(null);
    const divContainerRef = useRef(null);
    const mSearchKey = useRef('');
    const mIsSearching = useRef(false);
    const tableViewRef = useRef(null);
    const mLastSearchTimeoutIdRef = useRef<any>(0)
    const mSelectViewRef = useRef<any>(null);
    const mColumnCount = useRef(4);
    const mPropertyListRef = useRef<any>(null);
    const mIsDraging = useRef<any>(false);
    const locationParams = useLocation();
    // = useState<any>(null);//原始，第一次的排序方式。后面不管是编辑还是什么的，这个排序方式都不变会。哪怕是lastView  也不要刷新排序...


    const [sortMenu, setSortMenu] = useState([
        {
            key: "sort by",
            type: 'group',
            label: t('Sort by'),
            children: [
                {
                    key: 'sort by name',
                    label: t("alphabetical"),
                    icon: <CheckOutlined style={{color:'white',fontSize:'0px'}}/>
                },
                {
                    key: 'sort by createDate',
                    label: t('Date created')
                },
                {
                    key: 'sort by updateDate',
                    label: t('Last viewed')
                }
            ]
        },
        {
            key: "order",
            type: 'group',
            label: t('Order'),
            children: [
                {
                    key: 'date asc',
                    label: t('Oldest first')
                },
                {
                    key: 'date desc',
                    label: t('Newest first')
                }
            ]
        }
    ])

    const ARRAY_CARD_EXPORT = [
        {
            value:'exportPdf',
            label:t("ExportPDF"),
        },
        {
            value:'exportMarkdown',
            label:t("ExportMarkdown"),
        }]

    const ARRAY_OPERATOR_OPTIONS = ()=>{
        const menu = [
            {
                label:t('Is'),
                value:'is'
            },
            {
                label:t('Is not'),
                value:'isNot'
            },
            {
                label:t('Contains'),
                value:'contains'
            },
            {
                label:t('DoesNotContain'),
                value:'doesNotContain'
            },
            {
                label:t('Is empty'),
                value:'isEmpty'
            },
            {
                label:t('Is not empty'),
                value:'isNotEmpty'
            }
        ]
        return menu;
    }

    const ARRAY_PROPERTY_ADD_ITEM = ()=>{
        const menu = [
            getItem(<div className={'flex-row-vertical-center'}>{t("New card")}<span style={{marginLeft:'auto',color:'var(--text-color-bab8b8)'}}>C</span></div>, 'newItem',null, undefined, undefined, () => {
                //增加一个卡片
                const newCard = {
                    id:generateUUID2(),
                    name:'',
                    createTime:Date.now(),
                    updateTime:Date.now(),
                    isDeleted:0,
                    type:'card',
                    tags:[props.tagName],
                }
                updateCard(newCard).then(res=>{
                    if (selectView.type == 'gridView'){
                        window.showDialogCard(res);
                    }else{
                        // tableViewRef.current?.onAddItem(res);
                        window.showDialogCard(res);
                    }
                })

            }),
            getItem(t("From library"), 'fromLibrary',null, undefined, undefined, () => {
                //library 弹窗
                window.showDialogLink('','card',(item)=>{
                    if (isDeepLink(item)){
                        const deeplink = decodeDeeplink(item);
                        if (deeplink.type == 'project'){
                            getNoteById(deeplink.id,false).then((res:any)=>{
                                if (!isArray(res.tags)){
                                    res.tags = [];
                                }
                                if (res.tags.includes(props.tagName)){
                                    message.error(t('DataExists'));
                                }else{
                                    res.tags.push(props.tagName);
                                    updateProject(res).then(rrr=>{
                                        if (selectView.type == 'gridView'){
                                            refreshData();
                                        }else{
                                            tableViewRef.current?.onAddItem(res);
                                        }
                                    });
                                }

                            })
                        }else if (deeplink.type == 'library' || deeplink.type == 'highlight'){
                            let szId = deeplink.id;
                            if (deeplink.type == 'highlight'){
                                szId = deeplink.childId;
                            }
                            getCardById(szId).then((res:any)=>{
                                if (!isArray(res.tags)){
                                    res.tags = [];
                                }
                                if (res.tags.includes(props.tagName)){
                                    message.error(t('DataExists'));
                                }else {
                                    res.tags.push(props.tagName);
                                    updateCard(res).then(rrr => {
                                        if (selectView.type == 'gridView'){
                                            if (res.type == 'card'){
                                                if ((Date.now() - res.createTime) < 2000){
                                                    //这里认为是新建..
                                                    window.showDialogCard(res);
                                                }else{
                                                    refreshData();
                                                }
                                            }else{
                                                refreshData();
                                            }
                                        }else{
                                            if (res.type == 'card' && (Date.now() - res.createTime) < 2000){
                                                window.showDialogCard(res);
                                            }else{
                                                tableViewRef.current?.onAddItem(res);
                                            }
                                        }
                                    })
                                }
                            })
                        }
                    }

                })
            }),
        ]
        return menu;
    }

    useEffect(() => {
        const szPropertyListStatus = localStorage.getItem(KEY_PROPERTY_LIST_STATUS);
        if (szPropertyListStatus){
            setPropertyListStatus(JSON.parse(szPropertyListStatus));
        }

        updateSortStates();

        onSliderEvent();

        //取列表视图
        // refreshViewList();

        //刷新属性列表
        // refreshPropertyList();

    }, []);

    useEffect(() => {
        mSelectViewRef.current = selectView;
        window.refreshList['refresh_tag_view_list_'] = refreshViewList;
        window.refreshList['refresh_property_list_'] = refreshPropertyList;

        if (selectView){
            setFilterCount(selectView.conditions?.length || 0);
        }

        const selectViewInList = arrayViews.find(p=>p.id == selectView?.id);
        if (selectViewInList){
            selectViewInList.conditions = selectView.conditions;
        }

        //这里也清...
        mArrayOriginSort = null;

        return ()=>{
            delete window.refreshList['refresh_tag_view_list_'];
            delete window.refreshList['refresh_property_list_']
        }
    }, [arrayViews,selectView]);

    useEffect(() => {
        mSelectViewRef.current = null;
        setSelectView(null);
        //取列表视图
        refreshViewList(null);

        mMapIdCheck = {};
        // refreshData();
        mArrayOriginSort = null;//清空这个排序....

        window.refreshList['refresh_tag_item_list_'] = refreshData;
        return ()=>{
            delete window.globalRefreshList['refresh_tag_item_list_']
        }
    }, [props.tagName]);


    useEffect(() => {
        if (divContainerRef.current){
            const resizeObserver = new ResizeObserver(entries => {
                onSliderEvent();
            })
            resizeObserver.observe(divContainerRef.current);
        }
    }, [divContainerRef.current]);

    useEffect(()=>{
        // recvMessage(EVENT_REFRESH_TAG_LSIT,(msg,data)=>{
        //     refreshData();
        // })

        document.body.addEventListener('keydown',onKeydown);
        window.addEventListener('resize',onResize);

        return ()=>{
            // unSubscribe(EVENT_REFRESH_TAG_LSIT);
            document.body.removeEventListener('keydown',onKeydown);
            window.removeEventListener('resize',onResize);
        }
    })

    /**
     * 按键
     * @param event
     */
    function onKeydown(event){
        // debugLog('keydown',event);
        if (event.key == KEYS.ESCAPE){
            onCancelSelect();
            setIsShowChecked(false);
            //取消tableview的选择--
            if (tableViewRef.current){
                setRowSelectCount(0);
                tableViewRef.current?.onResetChecked();
            }
        }else if (event.key == KEYS.ENTER){
            handleFilterChanged(false);
        }
    }

    function onResize(event){
        onSliderEvent();
    }

    /**
     * 刷新属性列表
     */
    function refreshPropertyList(){
        getSortPropertyList().then(res=>{
            setArrayPropertys(res);
        })
    }

    /**
     * 刷新视图
     */
    function refreshViewList(newProperty:any){
        getViewList(props.tagName).then(async (res)=>{

            //每一个view添加一个
            // res.forEach(p=> {
            //     p.isSelected = false;
            // });
            if (res.length == 0){
                //没有的话就加一个默认的.
                const defaultView = {
                    id:'defaultView-'+generateUUID2(),
                    type:'tableView',
                    name:t('Table view'),
                    value:t('Table view'),
                    tagName:props.tagName,
                    viewSort:0,
                    conditions:undefined,
                    createTime:Date.now(),
                    columns:[{icon:'property_text',id:'name',name:'Name',width:280}]
                }
                res.push(defaultView);
                //保存到数据库
                await updateView(defaultView);
            }

            const arrayNewViews:any = [];

            arrayNewViews.push(...res);

            // arrayNewViews.push({
            //     id:'newView',
            //     name:t("Add view"),
            //     icon:'add_gray.svg',
            //     color:'var(--color-9A9A9A)'
            // })

            arrayNewViews.sort((a,b)=>{
                return a.createTime - b.createTime;
            })

            arrayNewViews.sort((a,b)=>{
                if (a.viewSort == undefined){
                    a.viewSort = 0;
                }
                if (b.viewSort == undefined){
                    b.viewSort = 0;
                }
                return a.viewSort - b.viewSort;
            })

            //是否有选择的，没有就第一个.
            if (!mSelectViewRef.current){
                let defaultSelectView = arrayNewViews.find(p=>p.isSelected);
                if (!defaultSelectView){
                    arrayNewViews[0].isSelected = true;
                    defaultSelectView = arrayNewViews[0];
                }
                arrayNewViews.forEach(pp=>{
                    if (pp != defaultSelectView){
                        pp.isSelected = false;
                    }
                })
                mSelectViewRef.current = defaultSelectView;
                setSelectView(defaultSelectView);
            }else{
                arrayNewViews.forEach(pp=>{
                    pp.isSelected = false;
                })
                const selectNewView = arrayNewViews.find(p=>p.id == (newProperty?.id || selectView.id));
                if (selectNewView){
                    selectNewView.isSelected = true;
                    mSelectViewRef.current = selectNewView;
                    setSelectView(selectNewView);
                }else{
                    //被删了？
                    const nIndex = arrayViews.findIndex(p=>p.id == selectView.id);
                    if (nIndex > 0){
                        arrayNewViews[nIndex -1].isSelected = true;
                    }
                    setSelectView(arrayNewViews[nIndex -1]);
                }
            }
            setArrayViews(arrayNewViews);

            //view后来请求属性-----
            const arrayProps = await getSortPropertyList();
            setArrayPropertys(arrayProps);
        })
    }


    /**
     * 获取三级的值
     * @param szType
     */
    const getFilterOptionValue = (szType)=>{
        let menu:any = [];
        if (szType == 'checkbox'){
            menu = [
                {
                    label:t('Checked'),
                    value:'checked'
                },
                {
                    label:t('Unchecked'),
                    value:'unchecked'
                }
            ]
        }
        return menu;
    }
    //导出配置.
    let importConfig = {};
    if (!isWeb()){
        importConfig = window.IPC.getConvertToken();
    }

    const editor = useEditor({
        autofocus:false,
        injectCSS: true,
        extensions: [
            StarterKit,
            Import.configure(importConfig),
            Export.configure(importConfig),
            Text,
            TextStyle,
            Color,
            UniqueID.configure({
                types: ['tableRow', 'taskList', 'listItem', 'taskItem', 'paragraph', 'image', 'blockquote', 'bulletList', 'orderedList', 'horizontalRule', 'youtube', 'table', 'highlight', 'latexBlock'],
                filterTransaction: transaction => {
                    return !transaction.getMeta('preventUpdate')
                }
            }),
            Heading.configure({
                levels: [1, 2, 3],
            }),
            Paragraph,
            Highlight.configure({ multicolor: true }),
            TextAlign.configure({
                types: ["heading", "paragraph"],
            }),
            Underline,
            // getBlockMenu(),
            Placeholder.configure({
                placeholder: '',
            }),
            FontSize,
            Indent,
            Link.configure({
                autolink:false,
                linkOnPaste:false,
            }),
            ImageT,
            Image.configure({
                allowBase64: true
            }),
            Hyperlink.configure({
                HTMLAttributes: {
                    target: '_self'
                }
            }),
            TaskList,
            TaskItem.configure({
                nested: true,
            }),
            HorizontalRule,
            Blockquote,
            Hyperlink.configure({
            }),
            FontFamily,
        ],
        editorProps: {
            attributes: {
                // class: '',
            },
        },
        parseOptions: {
            preserveWhitespace: 'full',
        },
    });

    const refreshDataWithFilter = (arrayTypes:any,szProjectId:any,szTag:any,szSearchKey:any)=>{
        mArrayTypes = arrayTypes;
        mszProjectId = szProjectId;
        mszTag = szTag;
        mszSearchKey = szSearchKey;
        refreshData();
    }

    /**
     * 刷新数据
     */
    const refreshData = ()=>{
        getProjectByTagName(props.tagName,mszTag,mszSearchKey).then(async (arrayNotes:any)=> {
            var arrayNewDatas: any = [...arrayNotes];
            //将card的也添加进来...
            const arrayCards: any = await getCardByTagName(props.tagName, mszTag, mszSearchKey);
            arrayNewDatas.push(...arrayCards);

            //将board也加进来
            const arrayBoards:any = await getBoardByTagName(props.tagName,mszTag,mszSearchKey);
            arrayNewDatas.push(...arrayBoards);

            //保持旧的选择的状态
            arrayNewDatas.forEach(p => {
                if (mMapIdCheck[p.id]) {
                    p.isChecked = true;
                }
            })

            arrayNewDatas = await filterData(arrayNewDatas, mArrayTypes, mszProjectId);
            sortData(arrayNewDatas);

            if (mArrayOriginSort){
                //这里还原这个序列..
                arrayNewDatas.sort((a,b)=>{
                    let nA = mArrayOriginSort[a.id];
                    let nB = mArrayOriginSort[b.id];
                    if (!nA){
                        nA = 0;
                    }
                    if (!nB){
                        nB = 0;
                    }
                    return nA - nB;
                })
            }else{
                mArrayOriginSort = {};
                //保存这个序列.
                for (let i=0;i<arrayNewDatas.length;i++){
                    mArrayOriginSort[arrayNewDatas[i].id] = i;
                }
            }
            setArrayDatas(arrayNewDatas);
            if (props.onRefreshDataFinished){
                props.onRefreshDataFinished();
            }

            setIsSearching(false);
        });
    }

    /**
     * 过滤数据
     * @param arrayNewDatas
     * @param arrayTypes
     * @param szProjectId
     */
    const filterData  = async (arrayNewDatas:any,arrayTypes:any,szProjectId:any)=>{
        const arrayNew = [];

        if (szProjectId){
            if (szProjectId == FILTER_PROJECT_ID_NOT_IN_PROJECT_ALL){
                //不在项目中的...
                const arrayInProjects = [];
                const arrayProjects:any = await getNoteList();
                for (let k=0;k<arrayNewDatas.length;k++){
                    const libraryItem = arrayNewDatas[k];
                    for (let i=0;i<arrayProjects.length;i++){
                        const projectData = await getNoteJsonDoc(arrayProjects[i].id);
                        let bHasExist = false;
                        for (let i=0;i<projectData.canvas.length;i++){
                            bHasExist = projectData.canvas[i].drawJson.elements.some(p=>p.id == libraryItem.id || p.customData?.generationData?.id == libraryItem.id);
                            if (bHasExist){
                                break;
                            }
                        }
                        if (bHasExist){
                            arrayInProjects.push(libraryItem);
                        }
                    }
                }

                for (let i=0;i<arrayNewDatas.length;i++){
                    const item = arrayNewDatas[i];
                    if (!arrayInProjects.some(p=>p.id == item.id)){
                        arrayNew.push(item);
                    }
                }

            }else if (szProjectId == FILTER_PROJECT_ID_ALL || szProjectId == FILTER_PROJECT_ID_ALL_0){
                arrayNew.push(...arrayNewDatas);
            }
            else if (szProjectId == FILTER_PROJECT_ID_ALL_IN_PROJECT){
                //在项目中的
                const arrayProjects:any = await getNoteList();
                for (let k=0;k<arrayNewDatas.length;k++){
                    const libraryItem = arrayNewDatas[k];
                    for (let i=0;i<arrayProjects.length;i++){
                        const projectData = await getNoteJsonDoc(arrayProjects[i].id);
                        let bHasExist = false;
                        for (let i=0;i<projectData.canvas.length;i++){
                            bHasExist = projectData.canvas[i].drawJson.elements.some(p=>p.id == libraryItem.id || p.customData?.generationData?.id == libraryItem.id);
                            if (bHasExist){
                                break;
                            }
                        }
                        if (bHasExist){
                            arrayNew.push(libraryItem);
                        }
                    }
                }

            }else{
                //某一项目中...
                const projectData = await getNoteJsonDoc(szProjectId);
                for (let k=0;k<arrayNewDatas.length;k++){
                    const libraryItem = arrayNewDatas[k];
                    let bHasExist = false;
                    for (let i=0;i<projectData.canvas.length;i++){
                        bHasExist = projectData.canvas[i].drawJson.elements.some(p=>p.id == libraryItem.id || p.customData?.generationData?.id == libraryItem.id);
                        if (bHasExist){
                            break;
                        }
                    }
                    if (bHasExist){
                        arrayNew.push(libraryItem);
                    }
                }
            }
        }else{
            arrayNew.push(...arrayNewDatas);
        }

        const arrayNewNew = [];
        for (let i=0;i<arrayNew.length;i++){
            const item = arrayNew[i];
            if (arrayTypes?.includes(item.type)){
                arrayNewNew.push(item);
            }
        }

        return arrayNewNew;
    }

    /**
     * 更新排序的描述
     * @param szSortType
     */
    const updateSortTypeDesc = (szSortType)=>{
        for(var i=0;i<sortMenu[0].children.length;i++){
            var item = sortMenu[0].children[i];
            if (item.key == szSortType){
                setSortTypeDesc(item.label);
                mSortTypeDesc = item.label;
            }
        }
    }

    /**
     * 排序
     * @param arrayCards
     */
    const sortData = (arrayCards:any)=>{
        let szSortType = localStorage.getItem(KEY_TAGITEM_SORT_TYPE) || "sort by updateDate";
        let szOrderBy = localStorage.getItem(KEY_TAGITEM_ORDER_BY) || "date desc";

        //更新排序描述文字
        updateSortTypeDesc(szSortType);

        //重新排序-------filterByProjectId后顺序被打乱了.
        if ("sort by name" === szSortType) {
            if ("a-z" === szOrderBy) {
                arrayCards.sort((a, b) => {
                    if (a.name == undefined || b.name == undefined) return 0;
                    return a.name.localeCompare(b.name);
                })
            } else if ("z-a" == szOrderBy) {
                arrayCards.sort((a, b) => {
                    if (a.name == undefined || b.name == undefined) return 0;
                    return b.name.localeCompare(a.name);
                })
            }
        } else if ("sort by createDate" == szSortType) {
            if ("date asc" == szOrderBy) {
                arrayCards.sort((a, b) => {
                    return a.createTime - b.createTime;
                })
            } else if ("date desc" == szOrderBy) {
                arrayCards.sort((a, b) => {
                    return b.createTime - a.createTime;
                })
            }
        } else if ("sort by updateDate" == szSortType) {
            if ("date asc" == szOrderBy) {
                arrayCards.sort((a, b) => {
                    return a.updateTime - b.updateTime;
                })
            } else if ("date desc" == szOrderBy) {
                arrayCards.sort((a, b) => {
                    return b.updateTime - a.updateTime;
                })
            }
        }
    }

    /**
     * 是否有选择条目
     */
    const hasCheckSelectedOk = ()=>{
        const arraySelectedItem = arrayDatas.filter(p=>p.isChecked);
        if (arraySelectedItem.length == 0){
            message.info(t("PleaseSelected"));
            return null;
        }
        return arraySelectedItem;
    }

    /**
     * 添加到项目
     */
    const addToProjectEvent = ()=>{
        const arraySelectItem = hasCheckSelectedOk();
        if (!arraySelectItem)return;
        window.showDialogChooseProject(arraySelectItem);
    }
    /**
     * 管理标签
     */
    const managerTagsEvent = ()=>{
        const arraySelectItem = hasCheckSelectedOk();
        if (!arraySelectItem)return;
        mMapIdCheck = {};
        arraySelectItem.forEach(p=>{
            mMapIdCheck[p.id] = true;
        })
        dialogTagManagerRef.current?.onShowDialog(arraySelectItem);
    }

    /**
     * 更改source
     */
    const changeSourceEvent = (item:any)=>{
        //选择的
        const arrayChecked:any = arrayDatas.filter(p=>p.isChecked);
        if (item){
            arrayChecked.push(item);
        }
        let bPdf = arrayChecked.some(p=>(p.type == 'pdf' || p.type == 'pdfAnno'));
        let bVideo = arrayChecked.some(p=>(p.type == 'video' || p.type == 'videoAnno'));
        let bAudio = arrayChecked.some(p=>(p.type == 'audio' || p.type == 'audioAnno'));
        if ((bPdf && bVideo) || (bPdf && bAudio) || (bVideo && bAudio)){
            message.error(t("PleaseChooseOnlyType"));
            return;
        }

        let filter = [{ name: 'Videos', extensions: ['mp4', 'mov', '3gp','mpeg'] }];
        if (bPdf){
            filter = [{ name: 'pdf', extensions: ['pdf'] }];
        }else if (bAudio){
            filter = [{ name: 'audio', extensions: getAudioFilterExt() }];
        }
        ipcInvoke('getFilePath',{filters:filter}).then(async (res)=>{
            if (res){
                for (let i=0;i<arrayChecked.length;i++){
                    let item = arrayChecked[i];
                    if (item.type == 'video' || item.type == 'pdf' || item.type == 'audio' || item.type == 'videoAnno' || item.type == 'pdfAnno' || item.type == 'audioAnno'){
                        if (item.type == 'pdfAnno' || item.type == 'videoAnno' || item.type == 'audioAnno'){
                            item = await getCardById(item.libraryId);
                        }
                        if (item.type == 'pdf' || item.type == 'video' || item.type == 'audio'){
                            await updateChangeSource(item.id,res);
                        }
                    }
                }
                //取消选中
                setIsShowChecked(false);
                mMapIdCheck = {};
                //刷新列表
                refreshData();
            }
        })
    }

    /**
     * 导出单个md
     * @param item
     */
    const onExportSingleMd = async (item:any)=>{
        window.showProgress(t("Exporting"))
        if (!item.doc){
            item.doc = await getCardDoc(item.id);
        }
        editor?.commands.setContent(item.doc);
        editor?.chain().export({
            format: 'md',
            onExport(context) {
                const { blob, error } = context
                if(error){
                    noteServer.openTip("error", t("ExportMarkdownFail"));
                    return;
                }
                blob.arrayBuffer().then(arrayBuffer => {
                    window.closeProgress();

                    ipcSend('save-markdown-to-system', arrayBuffer, item.name)
                });
            },
        })
    }


    //鼠标多选，点击
    const onMouseDown = (event:any)=>{
        if (event.button == 2)return;//右键不多选
        // 鼠标按下时才允许处理鼠标的移动事件
        select = true;
        mMouseDownTime = new Date().getTime();

        if (rect) {
            document.getElementById('divCardItemContainerInPageTag').removeChild(rect);
        }

        rect = document.createElement("div");
        // 框选div 样式
        rect.style.cssText = "position:absolute;width:0px;height:0px;font-size:0px;margin:0px;padding:0px;border:1px dashed #0099FF;background-color:#C3D5ED;z-index:1000;filter:alpha(opacity:60);opacity:0.6;display:none;";
        rect.id = "selectDiv";
        // 添加到lay1下
        document.getElementById('divCardItemContainerInPageTag').appendChild(rect);

        const divItemContainer = document.getElementById('divCardItemContainerInPageTag');
        let nScrollY = divItemContainer?.scrollTop;
        // 取得鼠标按下时的坐标位置
        const boundRect = event.currentTarget.getBoundingClientRect();
        downX = event.clientX - boundRect.left;
        downY = event.clientY - boundRect.top + nScrollY;
        rect.style.left = downX + "px";
        rect.style.top = downY + "px";
    }

    const onMouseUp = (event)=>{
        //鼠标抬起,就不允许在处理鼠标移动事件
        select = false;
        //隐藏图层
        if (rect) {
            try{
                document.getElementById('divCardItemContainerInPageTag').removeChild(rect);
            }catch (e){

            }

            rect = null;
        }
    }

    const onMouseMove = (event:any)=>{
        //如果有打开的对话框，这个不要处理了。。。。
        if(window.getDialogCardsCount() > 0)return;
        /*
                        这个部分,根据你鼠标按下的位置,和你拉框时鼠标松开的位置关系,可以把区域分为四个部分,根据四个部分的不同,
                        我们可以分别来画框,否则的话,就只能向一个方向画框,也就是点的右下方画框.

                        */
        // 取得鼠标移动时的坐标位置
        const divItemContainer = document.getElementById('divCardItemContainerInPageTag');
        let nScrollY:any = divItemContainer?.scrollTop || 0;

        const boundRect = event.currentTarget.getBoundingClientRect();
        // 取得鼠标移动时的坐标位置
        mouseX2 = event.clientX - boundRect.left;
        mouseY2 = event.clientY - boundRect.top + nScrollY;

        const time = new Date().getTime();

        if (Math.abs(mouseX2 - downX) < 8 && Math.abs(mouseY2 - downY) < 8 && (time - mMouseDownTime) < 500){
            // select = false;
            return;
        }

        if(select){

            //自动滚动

            // 显示框选元素
            if (rect.style.display == "none") {
                rect.style.display = "";
            }
            rect.style.left = Math.min(mouseX2, downX) + "px";

            rect.style.top = Math.min(mouseY2, downY) + "px";

            rect.style.width = Math.abs(mouseX2 - downX) + "px";

            rect.style.height = Math.abs(mouseY2 - downY) + "px";
            // A part
            if( mouseX2 < downX && mouseY2 < downY ){
                rect.style.left = mouseX2;
                rect.style.top = mouseY2 ;
            }

            // B part
            if( mouseX2 > downX && mouseY2 < downY){
                rect.style.left = downX ;
                rect.style.top = mouseY2;
            }

            // C part
            if( mouseX2 < downX && mouseY2 > downY){
                rect.style.left = mouseX2;
                rect.style.top = downY ;
            }

            // D part
            if( mouseX2 > downX && mouseY2 > downY ){
                rect.style.left = downX ;
                rect.style.top = downY;
            }

            //待选中的列表....
            var lis = document.querySelectorAll('[role="gridcell"]');//document.getElementsByClassName('carditem');
            var arrayNewList = [...arrayDatas];
            let nCheckedCount = 0;

            for (let i = 0; i < lis.length; i++) {
                //将移动的div的四个点和和div元素的四个点进行比较
                const cardItem = lis[i].firstChild;
                if (!cardItem)continue;
                //将移动的div的四个点和和div元素的四个点进行比较
                const arrayFilters = arrayNewList.filter(p=>p.id == cardItem.dataset.id);
                let item:any = null;
                if (arrayFilters.length > 0){
                    item = arrayFilters[0];
                }
                if (!item)continue;

                let nItemOffsetTop = lis[i].offsetTop;
                let nRectOffsetTop = rect.offsetTop ;//+ nScrollY;
                if (
                    //判断div元素 右边框的位置大于移动div的左起始点
                    rect.offsetLeft < (lis[i].offsetLeft + lis[i].offsetWidth ) &&
                    //判断div元素 下边框的位置大于移动div的上起始点
                    (nItemOffsetTop + lis[i].offsetHeight) >nRectOffsetTop
                    &&
                    // 判断div元素左边框的位置小于移动div的右起始点
                    rect.offsetLeft + rect.offsetWidth > lis[i].offsetLeft&&
                    // 判断div元素上边框的位置小于移动div的下起始点
                    nRectOffsetTop + rect.offsetHeight > nItemOffsetTop
                ) {
                    //将已选中的样式改变
                    item.isChecked = true;
                    nCheckedCount ++;
                } else {
                    //如果没有选中则清除样式
                    // item.isChecked = false;
                }
            }

            if (nCheckedCount > 0){
                if (!isShowChecked){
                    setIsShowChecked(true);
                }

                let szSelectedTitle = t("Items selected").replace('{0}',nCheckedCount+'');
                // setShowCheckedTitle(szSelectedTitle)
                setIsShowChecked(true);
                setOperButtonName(t("Cancel"));
                if (props.onSelectCallback){
                    props.onSelectCallback();
                }
            }
            setArrayDatas(arrayNewList);
        }

        // 阻止事件上传
        window.event.cancelBubble = true;
        // // 阻止默认事件
        window.event.returnValue = false;
    }

    /**
     * 拖动大小
     * @param nWidth
     */
    const onSliderEvent = ()=>{
        const divContainer = document.getElementById('divCardItemContainer-tagitem-list');
        if (!divContainer)return;
        const nWidth = divContainer.offsetWidth;
        // let COLUMN_COUNT = 3;
        // if (nWidth > 1380){
        //     COLUMN_COUNT = 5;
        //     setGridColumns('repeat(5,1fr)');
        // }else if (nWidth > 1000){
        //     COLUMN_COUNT = 4;
        //     setGridColumns('repeat(4,1fr)');
        // }else if (nWidth > 600){
        //     COLUMN_COUNT = 3;
        //     setGridColumns('repeat(3,1fr)');
        // }
        // else{
        //     COLUMN_COUNT = 2;
        //     setGridColumns('repeat(2,1fr)');
        // }


        if (nWidth > WIDTH_5){
            mColumnCount.current = 5;
            setGridColumns('repeat(5,auto)');
        }else if (nWidth > WIDTH_4){
            mColumnCount.current = 4;
            setGridColumns('repeat(4,auto)');
        }else if (nWidth > WIDTH_3){
            mColumnCount.current = 3;
            setGridColumns('repeat(3,auto)');
        }
        else{
            mColumnCount.current = 2;
            setGridColumns('repeat(2,auto)');
        }

        // if (props.subFromPage == 'DialogLink' || props.subFromPage == FROM_DIALOG || props.from == 'card'){
        //     mColumnCount.current = 3;
        //     setGridColumns('repeat(3,auto)');
        // }

        let fItemWidth = 200;
        const nMargin = (mColumnCount.current - 1)*12;
        fItemWidth = (nWidth - 12*2 - mColumnCount.current*16)/mColumnCount.current;//32为左右2边的边距
        setCardItemSize({
            width:fItemWidth,
            height:fItemWidth*0.67
        })
    }

    const cellRenderer = ({columnIndex, key, rowIndex, style})=>{
        let viewStyle:any = VIEW_STYLE.VIEW_STYLE_GRID;//getSysConfigSync(SYS_CONFIG_KEY_VIEW_STYLE);
        if(viewStyle == undefined){
          viewStyle = VIEW_STYLE.VIEW_STYLE_GRID;
        }else{
          viewStyle = viewStyle.value;
        }
        const item:any = arrayDatas[rowIndex*mColumnCount.current+columnIndex];
        if (!item){
            return <></>
        }
        if (item?.type == 'board'){
            return <div key={key} style={{...style,}}><BoardItem key={key} data={item} itemSize={cardItemSize} from={FROM_TAG} isShowChecked={isShowChecked}/></div>
        }
        if (item?.type && item?.type != 'project') {
            return <div key={key} style={{...style,}}><CardItem key={key} data={item}
                                                            itemWidth={cardItemSize.width}
                                                            itemHeight={cardItemSize.height} isTrash={true}
                                                            margin={'8px'}
                                                            searchKey={mszSearchKey}
                                                            isShowChecked={isShowChecked}
                                                            from={FROM_TAG} onCheckedCallback={() => {
            setCheckItemCount(arrayDatas.filter(p => p.isChecked).length);
        }} onActionCallback={async (szAction: string, item: any) => {
            //region  actioncallback
            if (szAction == 'delete') {
                dialogMessageRef.current?.onShowDialog(t("Tips"), t("ConfirmDeleteLibraryItem"), t("Delete"), () => {
                    item.isDeleted = 1;
                    item.deleteTime = Date.now();
                    if (!item.type || item.type == 'project') {
                        //删除项目
                        delNote(item);
                    } else {
                        updateCard(item).then(res => {
                            postMessage(EVENT_FAVIRIATE_CHANGE);
                            postMessage(EVENT_REFRESH_RECENTS);
                        });
                        //删除这个card所关联的项目
                        deleteAllCardFromRefProject(item);

                        //如果是视频注记，高亮删除也要更新
                        if (item.type == 'videoAnno' || item.type == 'audioAnno') {
                            dbGetHighlight(item.libraryId).then(r => {
                                if (r) {
                                    //删除这个注记
                                    const nIndex = r.data.findIndex(p => p.id == item.id);
                                    if (nIndex != -1) {
                                        r.data.splice(nIndex, 1);
                                        updateHighlight(r);
                                    }
                                }
                            })
                        }

                        //pdf注记删除，高亮删除也更新.
                        if (item.type == 'pdfAnno') {
                            ipcInvoke('remove-one-annotations', {id: item.id, pdfId: item.libraryId})
                        } else if (item.type == 'cardAnno') {
                            window.removeCardHighlight(item, () => {
                                postMessage(EVENT_REFRESH_LIBRARY_LIST);
                            });
                        }
                    }

                    const nIndex = arrayDatas.indexOf(item);
                    var arrayNewCards = [...arrayDatas];
                    arrayNewCards.splice(nIndex, 1);

                    setArrayDatas(arrayNewCards);
                })
            } else if (szAction == 'deleteChecked') {
                onDeleteChecked();
            } else if (szAction == 'rename') {
                dialogCommonInputRef.current?.onShowDialogAll(item.name, t("Rename") + " ".value, t("Cancel"), t("Save"), (szContent: string) => {
                    dialogCommonInputRef.current?.onCloseDialog();

                    item.name = szContent;
                    renameCard(item).then(res => {
                        //不知道啥排序，直接刷新列表。。
                        refreshData();
                        postMessage(EVENT_RENAME_LIBRARY_ITEM, {id: item.id, name: item.name})
                    });
                });
            } else if (szAction == 'exportCardPdf') {
                //card to pdf
                const szHtmlDoc: any = await getCardDoc(item.id);
                editDoc(item.id, szHtmlDoc, item.name).then(res => {
                    setTimeout(() => {
                        ipcSend('save-pdf-to-system', item.id, item.name)
                    }, 10);
                })
            } else if (szAction == 'exportPdf' || szAction == 'exportVideo' || szAction == 'exportAudio' || szAction == 'exportFile') {
                //导出文件
                const szFilePath = localStorage.getItem(KEY_FILE_DIR) + item.fileName;
                ipcSend('saveFile', {
                    filters: [{name: "All file", extensions: ['*']}],
                    filePath: szFilePath,
                    fileName: item.name + '.' + getFileNameExt(item.fileName)
                })
            } else if (szAction == 'managerTags') {
                //管理标签
                dialogTagManagerRef.current?.onShowDialog([item]);
            } else if (szAction == 'addToProject') {
                //添加到project.
                window.showDialogChooseProject([item]);
            } else if (szAction == 'makeACopy') {
                const szHtml = await getCardDoc(item.id);
                const newItem = {
                    ...item,
                    id: generateUUID2(),
                    name: item.name + "(" + t("Copy") + ")",
                    doc: szHtml
                }
                updateCard(newItem).then(res => {
                    refreshData();
                    message.info(t("Copyed"))
                });
            } else if (szAction == 'viewAllHighlights') {
                window.showPdfPreview(item.name, item.id, item.fileName, true, true)
            } else if (szAction == 'addToProjectChecked') {
                addToProjectEvent();
            } else if (szAction == 'managerTagsChecked') {
                managerTagsEvent();
            } else if (szAction == 'deleteChecked') {
                // deleteSelectedEvent();
            } else if (szAction == 'favor') {
                if (item.isFavirated) {
                    item.isFavirated = 0;
                } else {
                    item.isFavirated = 1;
                }
                item.favirateTime = Date.now();
                updateCard(item, false).then(res => {
                    postMessage(EVENT_FAVIRIATE_CHANGE);
                    refreshData();//刷新列表...
                });
            } else if (szAction == 'showInfo') {
                window.showInfo('library', item);
            } else if (szAction == 'versionHistory') {
                window.showDialogCardHistory(item.id);
            } else if (szAction == 'copyLink') {
                createCopyLinkByLibraryItem(item);
            } else if (szAction == 'select') {
                //选择这一个...
                // if (item.type == 'add' && props.type == 'image'){
                //     //添加图片
                //     setIsShowDialogChooseImage(true);
                //     setTimeout(()=>{
                //         dialogChooseImageRef.current?.onShowDialog();
                //     },150);
                // }else{
                //     if (props.onItemSelectedCallback){
                //         if (item.type == 'card'){
                //             item.doc = await getCardDoc(item.id);
                //         }
                //         props.onItemSelectedCallback(item);
                //     }
                // }
            } else if (szAction == 'exportMarkdown') {
                onExportSingleMd(item);
            } else if (szAction == 'add') {
                // onAddNewItem();
            } else if (szAction == 'edit') {
                const doc = await getCardDoc(item.id);
                Global.g_currentNoteData = {...item, doc};
                openEditor(item.id, false, props.from == FROM_LIBRARY, props.from);
            } else if (szAction == 'showInSystemExporler') {
                ipcSend("show-in-exporler", ((item.isAbsolutePath ? '' : localStorage.getItem(KEY_FILE_DIR))) + item.fileName)
            } else if (szAction == 'locateHighlight') {
                if (item.type == 'videoAnno' || item.type == 'audioAnno') {
                    const highlight = await dbGetHighlightByLibraryId(item.libraryId);
                    if (highlight) {
                        window.showVideoNotes(highlight, item.id)
                    }
                } else if (item.type == 'pdfAnno') {
                    const library = await getCardById(item.libraryId);
                    if (library) {
                        window.showPdfPreview(library.name, library.id, library.fileName, false, true, true, {highlightId: item.id});
                    } else {
                        message.error(t("Open error"))
                    }
                } else if (item.type == 'cardAnno') {
                    openEditor(item.libraryId, true, false, '', 'card', item.id);
                }

            } else if (szAction == 'changeSource') {
                changeSourceEvent(item);
            } else if (szAction == 'copyOriginLink') {
                clipboard.write(item.fileName);
                message.info(t("Link copied to clipboard"));
            } else if (szAction == 'openLink') {
                ipcSend('open-url', item.fileName);
            }
            //endregion
        }}/></div>
        }

        return <div key={key} style={{...style,}}><Note key={key} data={item} itemSize={cardItemSize} inTrash={false}
                                                        viewStyle={VIEW_STYLE.VIEW_STYLE_GRID}
                                                        onAction={(szAction: any, item: any) => {
                                                            if ("managerTags" == szAction) {
                                                                window.showManageTags([item]);
                                                            } else if ("changeThumbnail" == szAction) {
                                                                dialogChooseThumbRef.current?.onShowDialog((szImgName: any) => {
                                                                    //更新这个缩略图
                                                                    item.thumbUrl = szImgName;

                                                                    var arrayDatasNew: any = [...arrayDatas];
                                                                    const note = arrayDatasNew.find(p => p.id == item.id);
                                                                    if (note) {
                                                                        note.thumbUrl = szImgName;
                                                                        setArrayDatas(arrayDatasNew)
                                                                        //更新
                                                                        updateNote(note);
                                                                    }
                                                                });
                                                            }
                                                        }} from={FROM_TAG} isShowChecked={isShowChecked}/></div>
            }

            const getRowCount = ()=> {
                let nRowCount = arrayDatas.length / mColumnCount.current;
                nRowCount = Math.ceil(nRowCount);
                return nRowCount;
            }

    const renderCardList1 = ()=> {
        const div = document.getElementById('divCardItemContainer-tagitem-list');
        if (!div)return <></>
        const nWidth = div?.clientWidth - 13;//(document.body.clientWidth - homeLeftWidth - 10);
        let nHeight = (document.body.clientHeight - 100)
        return arrayDatas.length == 0 ? <></> : <Grid
            id={'divCardItemContainerInPageTag'}
            style={{padding: '0 0px', position: 'relative', outline: 'none',marginLeft:'0px',marginTop:'10px'}}
            cellRenderer={cellRenderer}
            columnCount={mColumnCount.current}
            rowCount={getRowCount()}
            rowHeight={cardItemSize.height + 16}
            columnWidth={cardItemSize.width + 16}
            height={nHeight}
            width={nWidth}
            // onScroll={({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth })=>{
            //     if (searchKey)return;//带搜索的不分页.
            //     const isBottom = Math.floor(scrollTop + clientHeight) >= Math.floor(scrollHeight);
            //     // console.log(he);
            //     if (isBottom && scrollTop > 0) {
            //         if (!mIsLoadingMore.current){
            //             mIsLoadingMore.current = (true)
            //
            //         }
            //         console.log('inbottom.....')
            //
            //         mPageNum.current++;
            //         //不是全部的项目了，不分页....
            //         if (!isAllProject()) {
            //             mPageNum.current = -1;
            //         }
            //
            //         console.log('pageNum:'+mPageNum.current)
            //         updateList()?.then(res=>{
            //             mIsLoadingMore.current = (false);
            //         })
            //     }
            // }}
        >
        </Grid>
    }

    /*渲染列表*/
    const renderNoteList =  () => {
        if (arrayDatas.length == 0) {
            return <span ref={divContainerRef} style={{position:'absolute',left:'240px',top:'50%',width:'calc(100% - 240px)',
                        color:'var(--text-color-66666)',
                        whiteSpace:'pre-wrap',
                        lineHeight:'22px',
                        textAlign:'center'}}>{t("LibraryIsEmptyTips")}</span>

        }

        return <div ref={divContainerRef} id={'divCardItemContainer'} style={{position:'relative'}} onMouseDown={onMouseDown} onMouseUp={onMouseUp} onMouseMove={onMouseMove}>
            {
                renderCardList1()
            }
        </div>

        /* 原列表，不用了。数据太多了卡
        let viewStyle:any = VIEW_STYLE.VIEW_STYLE_GRID;//getSysConfigSync(SYS_CONFIG_KEY_VIEW_STYLE);
        // if(viewStyle == undefined){
        //   viewStyle = VIEW_STYLE.VIEW_STYLE_GRID;
        // }else{
        //   viewStyle = viewStyle.value;
        // }

        return <div ref={divContainerRef} id={'divCardItemContainer'} style={{height:'100%',overflow:'hidden auto',padding:'0 20px',
            margin:'0 -20px',}} onMouseDown={onMouseDown} onMouseUp={onMouseUp} onMouseMove={onMouseMove}>
            <div style={{
            display: "grid",
            flexWrap: 'wrap',
            marginTop:'16px',
            gap:'16px 12px',
            alignItems:'flex-start',
            gridTemplateColumns:gridColumns,
            flexDirection: viewStyle === VIEW_STYLE.VIEW_STYLE_GRID ? "row" : "column",
        }} >
            {
                arrayDatas.map((item, i) =>{
                        if (item.type && item.type != 'project'){
                            return <CardItem key={i} data={item} itemWidth={0} itemHeight={0} isTrash={true} searchKey={mszSearchKey} isShowChecked={isShowChecked} from={FROM_TAG} onCheckedCallback={()=>{
                                setCheckItemCount(arrayDatas.filter(p => p.isChecked).length);
                            }} onActionCallback={async (szAction:string,item:any)=>{
                                if (szAction == 'delete') {
                                    dialogMessageRef.current?.onShowDialog(t("Tips"),t("ConfirmDeleteLibraryItem"),t("Delete"),()=>{
                                        item.isDeleted = 1;
                                        item.deleteTime = Date.now();
                                        if (!item.type || item.type == 'project'){
                                            //删除项目
                                            delNote(item);
                                        }else{
                                            updateCard(item).then(res=>{
                                                postMessage(EVENT_FAVIRIATE_CHANGE);
                                                postMessage(EVENT_REFRESH_RECENTS);
                                            });
                                            //删除这个card所关联的项目
                                            deleteAllCardFromRefProject(item);

                                            //如果是视频注记，高亮删除也要更新
                                            if (item.type == 'videoAnno' || item.type == 'audioAnno'){
                                                dbGetHighlight(item.libraryId).then(r=>{
                                                    if (r){
                                                        //删除这个注记
                                                        const nIndex = r.data.findIndex(p=>p.id == item.id);
                                                        if (nIndex != -1){
                                                            r.data.splice(nIndex,1);
                                                            updateHighlight(r);
                                                        }
                                                    }
                                                })
                                            }

                                            //pdf注记删除，高亮删除也更新.
                                            if (item.type == 'pdfAnno'){
                                                ipcInvoke('remove-one-annotations',{id:item.id,pdfId:item.libraryId})
                                            }else if (item.type == 'cardAnno'){
                                                window.removeCardHighlight(item,()=>{
                                                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                                                });
                                            }
                                        }


                                        const nIndex = arrayDatas.indexOf(item);
                                        var arrayNewCards = [...arrayDatas];
                                        arrayNewCards.splice(nIndex,1);

                                        setArrayDatas(arrayNewCards);
                                    })
                                }else if (szAction == 'deleteChecked'){
                                    onDeleteChecked();
                                }
                                else if (szAction == 'rename'){
                                    dialogCommonInputRef.current?.onShowDialogAll(item.name,t("Rename")+" ".value,t("Cancel"),t("Save"),(szContent:string)=>{
                                        dialogCommonInputRef.current?.onCloseDialog();

                                        item.name = szContent;
                                        renameCard(item).then(res=>{
                                            //不知道啥排序，直接刷新列表。。
                                            refreshData();
                                            postMessage(EVENT_RENAME_LIBRARY_ITEM,{id:item.id,name:item.name})
                                        });
                                    });
                                }else if (szAction == 'exportCardPdf'){
                                    //card to pdf
                                    const szHtmlDoc:any = await getCardDoc(item.id);
                                    editDoc(item.id,szHtmlDoc,item.name).then(res=>{
                                        setTimeout(() => {
                                            ipcSend('save-pdf-to-system', item.id, item.name)
                                        }, 10);
                                    })
                                }else if (szAction == 'exportPdf' || szAction == 'exportVideo' || szAction == 'exportAudio' || szAction == 'exportFile'){
                                    //导出文件
                                    const szFilePath = localStorage.getItem(KEY_FILE_DIR) + item.fileName;
                                    ipcSend('saveFile', {
                                        filters: [{name: "All file", extensions: ['*']}],
                                        filePath: szFilePath,
                                        fileName: item.name+'.'+getFileNameExt(item.fileName)
                                    })
                                }else if (szAction == 'managerTags'){
                                    //管理标签
                                    dialogTagManagerRef.current?.onShowDialog([item]);
                                }
                                else if (szAction == 'addToProject'){
                                    //添加到project.
                                    window.showDialogChooseProject([item]);
                                }else if (szAction == 'makeACopy'){
                                    const szHtml = await getCardDoc(item.id);
                                    const newItem = {
                                        ...item,
                                        id:generateUUID2(),
                                        name:item.name+"("+t("Copy")+")",
                                        doc:szHtml
                                    }
                                    updateCard(newItem).then(res=>{
                                        refreshData();
                                        message.info(t("Copyed"))
                                    });
                                }else if (szAction == 'viewAllHighlights'){
                                    window.showPdfPreview(item.name,item.id,item.fileName,true,true)
                                }else if (szAction == 'addToProjectChecked'){
                                    addToProjectEvent();
                                }else if (szAction == 'managerTagsChecked'){
                                    managerTagsEvent();
                                }else if (szAction == 'deleteChecked'){
                                    // deleteSelectedEvent();
                                }else if (szAction == 'favor'){
                                    if (item.isFavirated){
                                        item.isFavirated = 0;
                                    }else{
                                        item.isFavirated = 1;
                                    }
                                    item.favirateTime = Date.now();
                                    updateCard(item,false).then(res=>{
                                        postMessage(EVENT_FAVIRIATE_CHANGE);
                                        refreshData();//刷新列表...
                                    });
                                }else if (szAction == 'showInfo'){
                                    window.showInfo('library',item);
                                }else if (szAction == 'versionHistory'){
                                    window.showDialogCardHistory(item.id);
                                }
                                else if (szAction == 'copyLink'){
                                    createCopyLinkByLibraryItem(item);
                                }else if (szAction == 'select'){
                                    //选择这一个...
                                    // if (item.type == 'add' && props.type == 'image'){
                                    //     //添加图片
                                    //     setIsShowDialogChooseImage(true);
                                    //     setTimeout(()=>{
                                    //         dialogChooseImageRef.current?.onShowDialog();
                                    //     },150);
                                    // }else{
                                    //     if (props.onItemSelectedCallback){
                                    //         if (item.type == 'card'){
                                    //             item.doc = await getCardDoc(item.id);
                                    //         }
                                    //         props.onItemSelectedCallback(item);
                                    //     }
                                    // }
                                }else if (szAction == 'exportMarkdown'){
                                    onExportSingleMd(item);
                                }else if (szAction == 'add'){
                                    // onAddNewItem();
                                }else if (szAction == 'edit'){
                                    const doc = await getCardDoc(item.id);
                                    Global.g_currentNoteData = {...item, doc};
                                    openEditor(item.id,false,props.from == FROM_LIBRARY,props.from);
                                }else if (szAction == 'showInSystemExporler'){
                                    ipcSend("show-in-exporler",((item.isAbsolutePath?'':localStorage.getItem(KEY_FILE_DIR)))+item.fileName)
                                }else if (szAction == 'locateHighlight'){
                                    if (item.type == 'videoAnno' || item.type == 'audioAnno'){
                                        const highlight = await dbGetHighlightByLibraryId(item.libraryId);
                                        if (highlight) {
                                            window.showVideoNotes(highlight,item.id)
                                        }
                                    }else if (item.type == 'pdfAnno'){
                                        const library = await getCardById(item.libraryId);
                                        if (library) {
                                            window.showPdfPreview(library.name,library.id,library.fileName,false,true,true,{highlightId:item.id});
                                        }else {
                                            message.error(t("Open error"))
                                        }
                                    }else if (item.type == 'cardAnno'){
                                        openEditor(item.libraryId,true,false,'','card',item.id);
                                    }

                                }else if (szAction == 'changeSource'){
                                    changeSourceEvent(item);
                                }else if (szAction == 'copyOriginLink'){
                                    clipboard.write(item.fileName);
                                    message.info(t("Link copied to clipboard"));
                                }else if (szAction == 'openLink'){
                                    ipcSend('open-url',item.fileName);
                                }
                            }}/>
                        }
                        return <Note key={i} data={item} inTrash={false} viewStyle={viewStyle} onAction={(szAction:any,item:any)=>{
                            if ("managerTags" == szAction){
                                window.showManageTags([item]);
                            }else if ("changeThumbnail" == szAction){
                                dialogChooseThumbRef.current?.onShowDialog((szImgName:any)=>{
                                    //更新这个缩略图
                                    item.thumbUrl = szImgName;

                                    var arrayDatasNew:any = [...arrayDatas];
                                    const note = arrayDatasNew.find(p=>p.id == item.id);
                                    if (note){
                                        note.thumbUrl = szImgName;
                                        setArrayDatas(arrayDatasNew)
                                        //更新
                                        updateNote(note);
                                    }
                                });
                            }
                        }} from={FROM_TAG} isShowChecked={isShowChecked}/>
                    }
                )
            }
        </div></div>*/
    }

    /*tableview*/
    const renderTableview = ()=>{
        return <TableView ref={tableViewRef} tableView={selectView} tagName={props.tagName} szSearchKey={mszSearchKey} onRefreshCheck={(rowChecked)=>{
            //多选刷新..
            const arrayValues = Object.values(rowChecked);
            const nCheckedCount = arrayValues.filter(p=>p).length;
            setRowSelectCount(nCheckedCount);
        }}/>
    }
    /**
     * 取消选择
     */
    const onCancelSelect = ()=>{
        setOperButtonName(t("Select"));
        var arrayNew = [...arrayDatas];
        arrayNew.forEach(p => {
            delete p.isChecked;
        })
        setArrayDatas(arrayNew);
        props.onCancelCallback();
    }

    const onDeleteChecked = ()=>{
        const arraySelectItem = arrayDatas.filter(p=>p.isChecked);
        if (arraySelectItem.length == 0)return;
        dialogMessageRef.current?.onShowDialog(t("Tips"),t("ConfirmDeleteLibraryItems"),t("Delete"), async ()=>{

            for (let i=0;i<arraySelectItem.length;i++){
                arraySelectItem[i].isDeleted = 1;
                if (arraySelectItem[i].type){
                    await updateCard(arraySelectItem[i])
                }else{
                    await updateNote(arraySelectItem[i]);
                }
            }
            // if (props.onCancelCallback){
            //     props.onCancelCallback();
            // }
            //
            // setIsShowChecked(false);
            mMapIdCheck = {};
            //刷新列表
            refreshData();
        })
    }

    /**排序*/
    const onSortMenuClick = (e) => {
        if ("sort by name" == e.key || "sort by createDate" == e.key || "sort by updateDate" == e.key) {
            // updateSortOrderByMenu(e.key);
            setSortMenuOpen(true);
            localStorage.setItem(KEY_TAGITEM_SORT_TYPE,e.key);
            //默认选中Order by 的第一个.
            if("sort by name" == e.key){
                onSortMenuClick({key:'a-z'})
            }else{
                onSortMenuClick({key:'date desc'})
            }
        } else {
            setSortMenuOpen(false);
            localStorage.setItem(KEY_TAGITEM_ORDER_BY,e.key);
            //更新列表
            refreshData();
        }
        updateSortStates();
    }

    /*排序菜单显示状态更改*/
    const handleSortOpenChange = (nextOpen, info) => {
        if (info.source === 'trigger' || nextOpen) {
            setSortMenuOpen(nextOpen);
        }
    }

    /*排序状态选中*/
    const updateSortStates = async ()=>{
        let szSortType = localStorage.getItem(KEY_TAGITEM_SORT_TYPE);
        let szOrderBy = localStorage.getItem(KEY_TAGITEM_ORDER_BY);

        if(!szSortType){
            szSortType = "sort by updateDate";
        }
        if(!szOrderBy){
            szOrderBy = "date desc"
        }

        var arraySortMenus = [...sortMenu];
        if ("sort by name" == szSortType) {
            var sortMenuA = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'a-z',
                        label: 'A-Z',
                        icon: <CheckOutlined />,
                    },
                    {
                        key: 'z-a',
                        label: 'Z-A'
                    }
                ]
            }
            arraySortMenus[1] = sortMenuA;
        } else {
            var sortMenuDate = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'date asc',
                        label: t('Oldest first')
                    },
                    {
                        key: 'date desc',
                        label: t('Newest first')
                    }
                ]
            }
            arraySortMenus[1] = sortMenuDate;
        }

        var item0 = arraySortMenus[0];
        for(var i=0;i<item0.children.length;i++){
            var child = item0.children[i];

            if(child.key == szSortType){
                child.icon = <CheckOutlined />;
            }else{
                child.icon = <CheckOutlined style={{color:'white',fontSize:'0px'}}/>;
            }
        }

        var item1 = arraySortMenus[1];
        for(var i=0;i<item1.children.length;i++){
            var child = item1.children[i];

            if(child.key == szOrderBy){
                child.icon = <CheckOutlined />;
            }else{
                child.icon = <CheckOutlined style={{color:'white',fontSize:'0px'}}/>;
            }
        }

        setSortMenu(arraySortMenus);
    }

    const exportMarkdown = async ()=>{
        const arraySelectCards = getSelectedArray();
        if (arraySelectCards.length == 0){
            message.info(t("Please select"));
            return;
        }

        window.showProgress(t("Exporting"));

        const arrayBuffers:any = [];
        await recursionNext(0,arraySelectCards,arrayBuffers);
        window.closeProgress();

        let zip = new JSZip();
        for (let i=0;i<arrayBuffers.length;i++){
            const item = arrayBuffers[i];
            zip.file(item.name + Date.now() +'.md',item.bufs,{});
        }
        zip.generateAsync({type:"blob"}).then(function (content){
            saveAs(content,arraySelectCards[0].name +'.zip');
            message.info(t('Markdown exported successfully'))
        });

        // ipcSend('save-markdown-to-system', arrayBuffer, item.name)
    }

    const recursionNext = async (nIndex:number,arrayCards:any,arrayBufs:any)=>{
        for (let i=0;i<arrayCards.length;i++){
            const item = arrayCards[i];
            const doc:any = await getCardDoc(item.id);
            item.doc = doc;
            await onExportMd(item,arrayBufs);
        }
    }

    const onExportMd = (item:any,arrayBufs:any)=>{
        return new Promise((resolve, reject) => {
            editor?.commands.setContent(item.doc);
            editor?.chain().export({
                format: 'md',
                onExport(context) {
                    const { blob, error } = context
                    if(error){
                        noteServer.openTip("error", t("ExportMarkdownFail"));
                    }
                    blob?.arrayBuffer().then(async (bufs) => {
                        arrayBufs.push({
                            name:item.name,
                            bufs:bufs
                        });

                        resolve('');
                    });
                },
            })
        })
    }

    /**
     * 选中的数量
     */
    const getSelectedArray = ()=>{
        return arrayDatas.filter(p=>p.isChecked);
    }

    /**
     * 渲染搜索后缀
     */
    const renderSuffix = ()=>{
        if (isSearching){
            return<>
                <Spin indicator={<img className={'img-16 rotating-image mr-6'}
                                      src={getImagePathWithTheme('indicator_black')}/>} size={'small'}/>
            </>
        }else {
            return <img className='img-mini-small-8 cursor-pointer'
                        style={{display: isStringNullOrEmpty(searchKey) ? "none" : "inherit",marginRight:'6px'}}
                        onClick={() => {
                            setSearchKey('');
                            mSearchKey.current = '';
                            setIsSearching(false);
                            if (selectView.type == 'tableView'){
                                tableViewRef.current?.doSearch('');
                            }else{
                                mszSearchKey = mSearchKey.current;
                                refreshData();
                            }
                        }}
                        src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>
        }
    }

    const tagRender: any = useCallback((props,p) => {
        const column = mSelectViewRef.current.columns.find(pp => pp.id == p.columnId);
        const ttttaaaagggggg =  column?.items?.find(p => p.text == props.label);
        return (
            ttttaaaagggggg?
            <Tag
                closable={false}
                onClose={(e) => {

                }}
                className={'tableview-tag default-font-size'}
                style={{
                    backgroundColor: getPropertySelectOptionBackgroundColor(ttttaaaagggggg?.backgroundColor),
                    marginLeft: '0px',
                    color:'var(--text-color)'
                }}
            >
                {props.label}
            </Tag>:<></>
        );
    }, []);


    /**
     * filter过滤
     */
    const renderFilter = ()=>{
        const renderElementByType = (p)=>{
            const column = selectView.columns.find(pp => pp.id == p.columnId);
            const szType = column?.type || column?.id;
            if (column?.type == 'select' || column?.type == 'multiSelect'){
                const dbColumn = mPropertyListRef.current?.find(p=>p.id == column.id);
                if (dbColumn){
                    column.items = dbColumn.items;
                }
            }

            const isDisableInput = (p)=>{
                return p.operator == 'isEmpty' || p.operator == 'isNotEmpty'
            }

            if (szType == 'name' || szType == 'text' ||
                szType == 'url' || szType == 'notes' || szType == 'link' || szType == 'number' || szType == 'rating') {
                return <input id={'txt-filter-' + p.id}
                              className={`input-border ${isDisableInput(p) ? '' : 'input-border-focus'}`}
                              readOnly={p.operator == 'isEmpty' || p.operator == 'isNotEmpty'}
                              value={p.value} style={{flexGrow: '1', flexShrink: '0'}} onChange={(e) => {
                    if (isDisableInput(p)) {
                        return;
                    }
                    let szValue = e.currentTarget.value;
                    if (szType == 'number'){
                        szValue = filterNumericInput(e.currentTarget.value)
                        if (szValue && !isNumberOrFloat(szValue)){
                            return;
                        }
                    }else if (szType == 'rating'){
                        //只能输入1-5
                        if (szValue && !isNumber(szValue)){
                            return;
                        }
                        if (szValue){
                            const nNumber = parseInt(szValue);
                            if (nNumber <= 0 || nNumber > 5){
                                return;
                            }
                        }

                    }

                    const newSelectView = {...selectView};
                    const arrayNewConditions = [...newSelectView.conditions];
                    p.value = szValue;
                    newSelectView.conditions = arrayNewConditions;
                    setSelectView(newSelectView);
                }}/>
            }else if (szType == 'createTime' || szType == 'updateTime' || szType == 'date'){
                return <Popover arrow={false} open={isFilterSomeOpen[p.id]} trigger={['click']}
                                align={{offset: [-10, -12]}} onOpenChange={(e)=>{
                    const newOpen = {...isFilterSomeOpen};
                    newOpen[p.id] = e;
                    setIsFilterSomeOpen(newOpen);
                }}
                                placement={'topLeft'}
                                content={<PopupDate defaultDate={p.value}
                                                    from={'filter'}
                                                    onDateSelect={(longDate, hasClose = true) => {
                                                        const newSelectView = {...selectView};
                                                        const arrayNewConditions = [...newSelectView.conditions];
                                                        p.value = longDate;
                                                        newSelectView.conditions = arrayNewConditions;
                                                        setSelectView(newSelectView);
                                                        const newOpen = {...isFilterSomeOpen};
                                                        newOpen[p.id] = false;
                                                        setIsFilterSomeOpen(newOpen);
                                                    }}/>}>
                    <div style={{width:'100%'}}
                         className={'cursor-pointer span-single-line input-border flex-row-vertical-center'}>{formatDateCharDesc(p.value)}</div>
                </Popover>
            }else if (szType == 'checkbox'){
                return <Select value={p.value} style={{flexGrow: '1', flexShrink: '0'}}
                               virtual={false}
                               dropdownClassName={'shadow fix-gab-select-custom-option-render'}
                               suffixIcon={<img className='img-mini-small-10' onClick={() => {
                               }} src={getImagePathWithTheme('drop_down_select')}/>}
                               dropdownStyle={{width: '228px', overflowY: 'auto'}}
                               options={p.arrayValues}
                               optionRender={(option) => {
                                   return <div className={'flex-row-vertical-center'} style={{height:'100%',width:'100%'}} onClick={(e) => {
                                       const newSelectView = {...selectView};
                                       const arrayNewConditions = [...newSelectView.conditions];
                                       p.value = option.value;
                                       newSelectView.conditions = arrayNewConditions;
                                       setSelectView(newSelectView);
                                   }}>
                                       <span className={'ml-0'}>{option.label}</span>
                                   </div>
                               }}>
                </Select>
            }else if (szType == 'select' || szType == 'multiSelect'){
                const getOptions = ()=>{
                    let txt = document.getElementById('txt-select-filter-'+p.id);
                    if (txt){
                        let szTxt = txt.value.toLowerCase();
                        return column.items.filter(p=>p.text.toLowerCase().includes(szTxt));
                    }
                   return column.items;
                }
                if (isDisableInput(p)){
                    return <div className={'input-border'}></div>
                }
                return <Select value={p.value}
                               mode={"tags"}
                               virtual={false}
                               showSearch={false}
                               className={'hidden-ant-select-input'}
                               tagRender={(props)=>tagRender(props,p)}
                               open={mapFilterDropdownOpen[`select-${p.id}`]}
                               style={{flexGrow: '1', flexShrink: '0'}}
                               dropdownClassName={'shadow'}
                               onDropdownVisibleChange={(e)=>{
                                   const newMap = {...mapFilterDropdownOpen};
                                   newMap[`select-${p.id}`] = e;
                                   setMapFilterDropdownOpen(newMap);
                               }}
                               suffixIcon={<img className='img-mini-small-10' onClick={() => {
                               }} src={getImagePathWithTheme('drop_down_select')}/>}
                               dropdownStyle={{width: '228px', overflowY: 'auto'}}
                               options={getOptions()}
                               dropdownRender={(menus)=>{
                                   return<div className={'flex-col'}>
                                       <input id={'txt-select-filter-'+p.id} className={'input-border input-none'} placeholder={t('SearchForAnOption')} onChange={(e)=>{
                                            const newUUID = {...randomUUID};
                                            newUUID[p.id] = Date.now()+'';
                                            setRandomUUID(newUUID);
                                       }}/>
                                       <div key={randomUUID[p.id]} className={'line'} style={{margin:'0 -12px 6px -12px'}}></div>
                                       {
                                           getOptions().length == 0?<div className={'flex-center'} style={{minHeight:'150px'}}><span>{t('NoResults')}</span></div>:
                                           getOptions().map(option=>{
                                               return<div key={option.id} className={'flex-row-vertical-center cursor-pointer hovered-gray'} style={{height:'36px',padding:'0 6px'}} onClick={(e)=>{
                                                   const newSelectView = {...selectView};
                                                   const arrayNewConditions = [...newSelectView.conditions];
                                                   if (!isArray(p.value)) {
                                                       p.value = [];
                                                   }

                                                   const nIndex = p.value.findIndex(ppp=>ppp == option.text);
                                                   if (nIndex != -1) {
                                                       p.value.splice(nIndex,1);
                                                   }else {
                                                       p.value.push(option.text);
                                                   }
                                                   const arrayNewValue = [...p.value];
                                                   p.value = arrayNewValue;
                                                   newSelectView.conditions = arrayNewConditions;
                                                   setSelectView(newSelectView);
                                               }}>
                                                   <span style={{background:getPropertySelectOptionBackgroundColor(option.backgroundColor)}} className={'tableview-tag'}>{t(option.text)}</span>
                                                   {
                                                       p.value?.includes && p.value?.includes(option.text) &&
                                                       <img style={{width: '12px', height: '13px', marginLeft: 'auto'}}
                                                            src={getImagePathSvg('check_blue')}/>
                                                   }

                                               </div>
                                           })
                                       }
                                   </div>
                               }}
                >
                </Select>
            }

            return <div className={'input-border'}></div>
        }

        return <div className={'flex-col default-font-size'} style={{minHeight: '110px'}}>
            <div className={'flex-row-vertical-center'}>
                <span className={'font-family-medium'}>{t("Filter")}</span>
                <div className={'flex-row-vertical-center cursor-pointer'} style={{marginLeft: 'auto'}} onClick={() => {
                    const newSelectView = {...selectView};
                    if (!newSelectView.conditions) {
                        newSelectView.conditions = [];
                    }
                    newSelectView.conditions.push({
                        id: generateUUID2(),
                        columnId: '',
                        operator: '',
                        value: '',
                        arrayOperators: [],
                        arrayValues:[]
                    })
                    setSelectView(newSelectView);
                }}>
                    <img className={'img-14'} src={getImagePathWithThemeSvg('add_blue')}/>
                    <span className={'primary-color ml-4'}>{t("Add condition")}</span>
                </div>
            </div>
            {
                selectView?.conditions?.length > 0 ? <div className={'flex-col'}>
                    {
                        selectView.conditions.map((p,index)=> {
                            return <div className={'flex-row-vertical-center'} style={{
                                display: "grid",
                                gridTemplateColumns: 'minmax(1px, 0.3fr) minmax(1px, 0.3fr) minmax(1px, 0.4fr) 20px',
                                gap: '0 12px',
                                marginTop: '12px'
                            }}>
                                {/*//第一个*/}
                                <Select value={selectView.columns?.find(pp => pp.id == p.columnId)?.name}
                                        style={{flexGrow: '1', flexShrink: '0'}}
                                        virtual={false}
                                        dropdownClassName={'shadow fix-gab-select-custom-option-render'}
                                        suffixIcon={<img className='img-mini-small-10' onClick={() => {
                                        }} src={getImagePathWithTheme('drop_down_select')}/>}
                                        dropdownStyle={{width: '228px', overflowY: 'auto'}}
                                        options={selectView.columns}
                                        labelRender={(e)=>{
                                            const column = selectView.columns?.find(pp => pp.name == e.value)
                                            return <div className={'flex-row-vertical-center'}>
                                                <img className={'img-14'}
                                                     src={getImagePathWithThemeSvg(column.icon)}/>
                                                <span className={'ml-6'}>{column.groupName == 'default'?t(column.name):column.name}</span>
                                            </div>
                                        }}
                                        optionRender={(option) => {
                                            return <div key={option.data.id} className={'flex-row-vertical-center'} style={{height:'100%',width:'100%'}} onClick={(e) => {

                                                const newSelectView = {...selectView};
                                                const arrayNewConditions = [...newSelectView.conditions];
                                                p.columnId = option.data.id;
                                                p.type = option.data.type;
                                                const column = selectView.columns.find(pp => pp.id == p.columnId);
                                                p.arrayOperators = getFilterOperator(column.type || column.id);
                                                if (column.type == 'checkbox'){
                                                    p.operator = 'is';
                                                    p.arrayValues = getFilterOptionValue(column.type || column.id);
                                                }else {
                                                    p.operator = '';
                                                }
                                                p.value = '';
                                                newSelectView.conditions = arrayNewConditions;

                                                setSelectView(newSelectView);
                                            }}>
                                                <img className={'img-14'} src={getImagePathWithThemeSvg(option.data.icon)}/>
                                                <span className={'ml-6'}>{t(option.data.name)}</span>
                                            </div>
                                        }}
                                >
                                </Select>
                                {/*//第二个*/}
                                <Select value={p.operator}
                                        virtual={false}
                                        open={mapFilterDropdownOpen[p.id]} style={{flexGrow: '1', flexShrink: '0'}}
                                        dropdownClassName={'shadow fix-gab-select-custom-option-render'}
                                        onDropdownVisibleChange={(e)=>{

                                            const newMap = {...mapFilterDropdownOpen};
                                            newMap[p.id] = e;
                                            if (p.type == 'checkbox') {
                                                newMap[p.id] = false;
                                            }

                                            setMapFilterDropdownOpen(newMap);
                                        }}
                                        suffixIcon={p.type == 'checkbox'?<></>:<img className='img-mini-small-10' onClick={() => {
                                        }} src={getImagePathWithTheme('drop_down_select')}/>}
                                        dropdownStyle={{width: '228px', overflowY: 'auto'}}
                                        options={p.arrayOperators}
                                        optionRender={(option) => {
                                            return <div className={'flex-row-vertical-center'} style={{height:'100%',width:'100%'}} onClick={(e) => {
                                                const newSelectView = {...selectView};
                                                const arrayNewConditions = [...newSelectView.conditions];
                                                p.operator = option.value;
                                                if (p.operator == 'isEmpty' || p.operator == 'isNotEmpty'){
                                                    p.value = '';
                                                }
                                                newSelectView.conditions = arrayNewConditions;
                                                setSelectView(newSelectView);
                                            }}>
                                                <span className={'ml-0'}>{option.label}</span>
                                            </div>
                                        }}>
                                </Select>
                                {
                                    //第三个类型
                                    renderElementByType(p)
                                }

                                <img className={'img-16 cursor-pointer'}
                                     src={getImagePathWithTheme('filter_remove')} onClick={() => {
                                    const newSelectView = {...selectView};
                                    const arrayNewConditions = [...newSelectView.conditions];
                                    const nIndex = arrayNewConditions.findIndex(pp=>pp.id == p.id);
                                    arrayNewConditions.splice(nIndex,1);
                                    newSelectView.conditions = arrayNewConditions;
                                    setSelectView(newSelectView);
                                }}/>
                            </div>
                        })
                    }
                </div> : <div className={'flex-center'} style={{flexGrow: '1'}}>
                    <span style={{color: 'var(--text-color-bab8b8)'}}>{t("NoConditionsYet")}</span>
                </div>
            }
        </div>
    }

    /**
     * 添加新的属性列到 列表视图
     * @param p
     */
    const addNewPropertyToTableView = (p)=>{
        const newView = {...selectView};
        const arrayNewCols = [...selectView.columns]
        arrayNewCols.push(p);
        newView.columns = arrayNewCols;


        updateView(newView).then(res => {
            global.g_tableviewUpdateProperty = true;
            //刷新列表？
            mSelectViewRef.current = newView;
            setSelectView(newView);

            //刷新当前view列表
            const arrayNewViews: any = [...arrayViews];
            const view = arrayNewViews.find(p => p.id == newView.id);
            view.columns = arrayNewCols;
            setArrayViews(arrayNewViews);
        });
    }

    /**
     * 过滤条件....
     * @param e
     */
    const handleFilterChanged = (e)=>{
        if (!e) {
            const newOpen = {...mapFilterDropdownOpen};
            //关闭全部的select
            const arrayKeys = Object.keys(newOpen);
            for (let i = 0; i < arrayKeys.length; i++) {
                const szKey = arrayKeys[i];
                if (szKey.startsWith('select')) {
                    newOpen[szKey] = false;
                }
            }
            setMapFilterDropdownOpen(newOpen);

            //移除全部为空的，排除isEmpty or isNotEmpty
            if (selectView.conditions){
                const newSelectView = {...selectView};
                const arrayNewConditions = [];
                for (let i=0;i<newSelectView.conditions.length;i++) {
                    const condition = newSelectView.conditions[i];
                    if (condition.columnId){
                        if (condition.operator){
                            if (condition.operator == 'isEmpty' || condition.operator == 'isNotEmpty'){
                                arrayNewConditions.push(condition);
                            }else if (condition.value){
                                arrayNewConditions.push(condition);
                            }
                        }
                    }
                }
                newSelectView.conditions = arrayNewConditions;
                setSelectView(newSelectView);
            }

            setTimeout(() => {
                setIsFilterOpen(e);
            }, 10)
        } else {
            setIsFilterOpen(e);
        }
    }

    /**
     * 添加属性
     */
    const renderPropertyList = () => {
        const isInUse = (property) => {
            return mSelectViewRef.current?.columns?.some(p => p.id == property.id);
        }


        /**
         * 属性列表item
         * @param szType
         */
        const renderPropertyItem = (szType)=>{
            const arrayPros = arrayPropertys.filter(p=>p.groupName == szType);
            return arrayPros.map(p => {
                const isIn = isInUse(p);
                return <div
                    className={`flex-row-vertical-center hovered-gray show-image-in-hover default-font-size ${isIn ? '' : 'cursor-pointer'}`}
                    style={{
                        height: propertyListStatus[szType]?'36px':'0px',
                        minHeight: propertyListStatus[szType]?'36px':'0px',
                        opacity: '1',//isInUse(p) ? '0.5' : '1',
                        cursor: 'pointer',//isIn ? 'not-allowed' : 'pointer',
                        overflow:'hidden',
                        padding:'0 12px'
                    }} onClick={() => {
                    //添加属性
                    if (isIn) {
                        if (p.id == 'name') return;
                        //删除
                        const newView = {...selectView};
                        const arrayNewColumns:any = [];
                        for (let i=0;i<newView.columns.length;i++){
                            const item = newView.columns[i];
                            if (item.id != p.id){
                                arrayNewColumns.push(item);
                            }
                        }
                        newView.columns = arrayNewColumns;
                        //这里要判断一下，当前的排序列是不是还可见，如果不可见的话就删了。。。
                        if (newView.sortColumn){
                            if (!newView.columns.some(p=>p.id == newView.sortColumn.id)){
                                delete newView.sortColumn;
                            }
                        }

                        mSelectViewRef.current = newView;

                        updateView(newView).then(res=>{
                            //刷新tableview列表
                            setSelectView(newView);
                            //刷新当前view列表
                            const arrayNewViews:any = [...arrayViews];
                            const view = arrayNewViews.find(p=>p.id == newView.id);
                            view.columns = arrayNewColumns;
                            setArrayViews(arrayNewViews);
                        });
                        return;
                    }
                    //添加属性....
                    addNewPropertyToTableView(p);
                }} onMouseEnter={(e)=>{
                    //这里统计
                    staticTagsInColumn(p.id).then(res=>{
                        const mapNew = {...mapColumnInTags};
                        mapNew[p.id] = res;
                        setMapColumnInTags(mapNew);
                    })
                }}>
                    <img className={'img-16'} src={getImagePathWithThemeSvg(p.icon)}/>
                    <span className={'ml-8 span-single-line'}>{szType == 'default'?t(p.name):p.name}</span>
                    <div className={'flex-row-vertical-center'} style={{marginLeft:'auto'}}>
                        {
                            mapColumnInTags[p.id] &&
                            //统计这个列被哪些tag使用.
                            <Tooltip arrow={false} title={mapColumnInTags[p.id]}>
                                <img className={'img-16 show-image-in-hover'} src={getImagePathWithThemeSvg('property_in_used_tag')}/>
                            </Tooltip>
                        }
                        <Checkbox checked={isIn} style={{marginLeft:'12px'}}/>
                        {
                            // isIn &&
                            // <span className={'ml-6'}>{`(${t("In use")})`}</span>
                        }
                    </div>

                </div>
            })
        }

        return <div className={'default-font-family'}>
            <span className={'dialog-title'} style={{margin:'0 12px'}}>{t('Add property')}</span>
            <div className={'line'} style={{margin: '12px 0px'}}></div>
            <Input className={'input-border'} style={{width: 'calc(100% - 24px)',margin:'0 12px'}}
                   variant={"borderless"}
                   value={searchProperty}
                   suffix={renderSuffix()} placeholder={t('Search properties')} onChange={(event) => {
                setSearchProperty(event.currentTarget.value);
                const szSearch = event.currentTarget.value.toLowerCase();
                if (!szSearch) {
                    refreshPropertyList();
                } else {
                    const arrayNewPropertys: any = [];
                    for (let i = 0; i < arrayPropertys.length; i++) {
                        const item = arrayPropertys[i];
                        if (item.name.toLowerCase().includes(szSearch)) {
                            arrayNewPropertys.push(item);
                        }
                    }
                    setArrayPropertys(arrayNewPropertys);
                }
            }}/>

            <div className={'flex-col mt-6 default-font-size'} style={{
                maxHeight: `${document.body.offsetHeight * 0.5}px`,
                overflowY: 'auto',
                userSelect:'none',
            }}>
                <div>
                    <div className={'flex-row-vertical-center cursor-pointer'} style={{height: '32px',userSelect:'none',margin:'0 12px'}}
                         onClick={(e) => {
                            const newPropertyStatus = {...propertyListStatus};
                            newPropertyStatus['default'] = !newPropertyStatus['default'];
                            setPropertyListStatus(newPropertyStatus);
                            localStorage.setItem(KEY_PROPERTY_LIST_STATUS,JSON.stringify(newPropertyStatus));
                         }}>
                        <img className={'img-16'} src={getImagePathWithThemeSvg(propertyListStatus['default']?'property_dropdown_expand':'property_dropdown_collapse')}/>
                        <span className={'ml-6 font-family-semi-bold'}>{t('System properties')}</span>
                    </div>
                    {
                        renderPropertyItem('default')
                    }
                </div>
                {
                    arrayPropertys.filter(p => p.groupName == 'custom').length > 0 &&
                    <div>
                        <div className={'flex-row-vertical-center cursor-pointer'}
                             style={{height: '32px', userSelect: 'none', margin: '0 12px'}}
                             onClick={(e) => {
                                 const newPropertyStatus = {...propertyListStatus};
                                 newPropertyStatus['custom'] = !newPropertyStatus['custom'];
                                 setPropertyListStatus(newPropertyStatus);
                                 localStorage.setItem(KEY_PROPERTY_LIST_STATUS, JSON.stringify(newPropertyStatus));
                             }}>
                            <img className={'img-16'}
                                 src={getImagePathWithThemeSvg(propertyListStatus['custom'] ? 'property_dropdown_expand' : 'property_dropdown_collapse')}/>
                            <span className={'ml-6 font-family-semi-bold'}>{t('Custom properties')}</span>
                        </div>
                        {
                            renderPropertyItem('custom')
                        }
                    </div>
                }

                {
                    // arrayPropertys.map(p => {
                    //     const isIn = isInUse(p);
                    //     return <div
                    //         className={`flex-row-vertical-center default-font-size ${isIn ? '' : 'cursor-pointer'}`}
                    //         style={{
                    //             height: '36px',
                    //             minHeight: '36px',
                    //             opacity: isInUse(p) ? '0.5' : '1',
                    //             cursor: isIn ? 'not-allowed' : 'pointer'
                    //         }} onClick={() => {
                    //         //添加属性
                    //         if (isIn) {
                    //             if (p.id == 'name') return;
                    //             return;
                    //         }
                    //         //添加属性....
                    //         addNewPropertyToTableView(p);
                    //     }}>
                    //         <img className={'img-16'} src={getImagePathWithThemeSvg(p.icon)}/>
                    //         <span className={'ml-8'}>{t(p.name)}</span>
                    //         {
                    //             isIn &&
                    //             <span className={'ml-6'}>{`(${t("In use")})`}</span>
                    //         }
                    //     </div>
                    // })
                }
            </div>
            <div className={'line'} style={{margin: '6px 0px 12px 0px'}}></div>
            <div className={'flex-row-vertical-center cursor-pointer default-font-size'} onClick={(e) => {
                setIsAddPropertyOpen(false);
                window.showDialogAddProperty(null, (newProperty) => {
                    addNewPropertyToTableView(newProperty);
                });
            }} style={{margin:'0 12px'}}>
                <img className={'img-16'} src={getImagePathWithThemeSvg('add_blue')}/>
                <span className={'ml-8'} style={{color: 'var(--primary-color)'}}>{t('CreateNewProperty')}</span>
            </div>

            <div className={'flex-row-vertical-center cursor-pointer default-font-size mt-10'}
                 style={{height: '26px',margin:'10px 12px 0px 12px'}} onClick={() => {
                //转到property
                window.navPage('property');
            }}>
                <img className={'img-16'} src={getImagePathWithThemeSvg('manage_properties')}/>
                <span className={'ml-8'}>{t('Manage properties')}</span>
            </div>
        </div>
    }

    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;
        if (!over) {
            return;
        }
        if (active.id !== over.id) {
            let arrayNew = [...arrayViews];

            const oldIndex = arrayNew.findIndex((item) => item.id === active.id);
            const newIndex = arrayNew.findIndex((item) => item.id === over.id);
            arrayNew = arrayMove(arrayNew, oldIndex, newIndex);
            setArrayViews(arrayNew);

            for (let i=0;i<arrayNew.length;i++){
                arrayNew[i].viewSort = i;
            }
            batchUpdateViews(arrayNew);

            // setItems((data) => {
            //     const oldIndex = data.findIndex((item) => item.id === active.id);
            //     const newIndex = data.findIndex((item) => item.id === over.id);
            //     return arrayMove(data, oldIndex, newIndex);
            // });
        }
    };

    const handleDragMove = (event)=>{
        mIsDraging.current = true;
    }


    const commonStyle: React.CSSProperties = {
        cursor: 'pointer',
        transition: 'unset', // Prevent element from shaking after drag
    };
    const DraggableItem: React.FC<any> = memo((props) => {
        const {p} = props;
        let {listeners, transform, transition, isDragging, setNodeRef} = useSortable({id: props.p.id});
        const style = transform
            ? {
                ...commonStyle,
                transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
                transition: isDragging ? 'unset' : transition, // Improve performance/visual effect when dragging
            }
            : commonStyle;

        return <div ref={setNodeRef} className={'flex-row-vertical-center cursor-pointer view-item'}  {...listeners} style={{
            ...style,
            height: '30px',
            padding: '0 14px',
            borderRadius: '8px',
            flexShrink: '0',
            background: p.isSelected ? '#3670F733' : ''
        }}
                    onMouseUp={(e) => {
                        mszSearchKey = mSearchKey.current = '';
                        setSearchKey('');

                        if (p.id == 'newView') {
                            window.showDialogAddView(null, props.tagName, (newView) => {

                            });
                            return;
                        }
                        if (p.isSelected){
                            window.showDialogAddView(p);
                            return;
                        }
                        const arrayNew = [...arrayViews];
                        arrayNew.forEach(pp => pp.isSelected = false);
                        p.isSelected = true;
                        mSelectViewRef.current = p;
                        setSelectView(p);
                        setArrayViews(arrayNew);
                        //保存.
                        batchUpdateViews(arrayNew);
                        if (p.type == 'gridView'){
                            refreshData();//刷新
                        }
                    }} onMouseDown={(e) => {
            if (e.button == 2) {
                window.showDialogAddView(p);
            }
        }}>
            {
                p.icon &&
                <img className={'img-14 mr-6'} src={getImagePathWithTheme(p.icon)}/>
            }
            <span style={{color: p.isSelected ? 'var(--primary-color)' : p.color,}}>{p.name}</span>
        </div>
    })

    const renderTagItemList = ()=>{
        return (
            <>
                <div className={'flex-row-vertical-center mt-15'} style={{position: 'relative'}}>
                    <div className={'flex-row-vertical-center'} style={{width: '100%'}}>
                        {
                            // props.from != 'favor' &&
                            // <img className={'img-18 mr-4'} src={getImagePathWithTheme('nav_back')}/>
                        }

                        {
                            isShowChecked ? <div className={'flex-row-vertical-center'}>
                                <span className='header-title font-family-semi-bold'>
                                {
                                    t("Items selected").replace('{0}', arrayDatas?.filter(p => p.isChecked).length)
                                }
                            </span>
                                    <div
                                        className={'button-border-gray-style flex-center hovered-text-main-blue-color ml-16'}
                                        style={{
                                            minWidth: '76px',
                                            height: '32px',
                                            fontSize: '13px',
                                            fontFamily: 'Poppins',
                                            padding: '0 16px',
                                            border: '1px solid var(--button-no-fill-border-color)'
                                        }} onClick={() => {
                                        onCancelSelect();
                                        setIsShowChecked(false);
                                    }}>
                                        {t('Cancel')}
                                    </div>
                                </div> :
                                <div className={'flex-row-vertical-center'} style={{flexGrow: '1'}} onClick={() => {
                                    // if (props.from != 'favor') {
                                    //     if (props.onBackCallback) {
                                    //         props.onBackCallback();
                                    //     }
                                    // }
                                }}>
                                    {/*<span className='header-title font-family-semi-bold' onClick={()=>{*/}
                                    {/*    if (props.onBackCallback) {*/}
                                    {/*        props.onBackCallback();*/}
                                    {/*    }*/}
                                    {/*}}*/}
                                    {/*      style={{marginBottom: '0px', display: 'block', marginLeft: '0px'}}>{t("Tags")} /&nbsp;</span>*/}

                                    {/*<span className='header-title font-family-semi-bold'*/}
                                    {/*      style={{*/}
                                    {/*          marginBottom: '0px',*/}
                                    {/*          display: 'block',*/}
                                    {/*          marginLeft: '0px'*/}
                                    {/*      }}>#{props.tagName}</span>*/}

                                    {/*view header*/}
                                    <div className={'flex-row-vertical-center'} style={{gap:'0 10px',flexGrow:'1',height:'34px',overflowX:'hidden',overflowY:'hidden', marginRight:'16px'}}>
                                        {
                                            rowSelectCount == 0?
                                                <div className={'flex-row-vertical-center'}>
                                                    <DndContext onDragEnd={handleDragEnd} onDragMove={handleDragMove}>
                                                        <SortableContext items={arrayViews}
                                                                         strategy={horizontalListSortingStrategy}>
                                                            <div className={'flex-row-vertical-center'} style={{gap: '0 10px',height:'34px',overflowX:'auto',overflowY:'hidden'}}>
                                                                {
                                                                    arrayViews.map(p => {
                                                                        return (
                                                                            <DraggableItem p={p}/>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </SortableContext>
                                                    </DndContext>
                                                    <div
                                                        className={'flex-row-vertical-center cursor-pointer view-item'}
                                                        style={{
                                                            height: '30px',
                                                            padding: '0 14px',
                                                            borderRadius: '8px',
                                                            flexShrink: '0',
                                                        }}
                                                        onClick={(e) => {
                                                            window.showDialogAddView(null, props.tagName, (newView) => {

                                                            },selectView);
                                                        }} onMouseDown={(e) => {
                                                        if (e.button == 2) {
                                                            window.showDialogAddView(p);
                                                        }
                                                    }}>
                                                        {
                                                            <img className={'img-14 mr-6'} src={getImagePathWithTheme('add_gray.svg')}/>
                                                        }
                                                        <span
                                                            style={{color: 'var(--color-9A9A9A)'}}>{t("Add view")}</span>
                                                    </div>
                                                </div>
                                                : <div className={'flex-row-vertical-center'}>
                                            <span
                                                className='header-title font-family-semi-bold select----'>{t('Items selected').replace('{0}', `${rowSelectCount}`)}</span>
                                                    <div
                                                        className={'button-border-gray-style flex-center hovered-text-main-blue-color ml-16'}
                                                        style={{
                                                            minWidth: '76px',
                                                            height: '32px',
                                                            fontSize: '13px',
                                                            fontFamily: 'Poppins',
                                                            padding: '0 16px',
                                                            border: '1px solid var(--button-no-fill-border-color)'
                                                        }} onClick={() => {
                                                        setRowSelectCount(0);
                                                        tableViewRef.current?.onResetChecked();
                                                    }}>
                                                        {t('Cancel')}
                                                    </div>
                                                </div>
                                        }
                                    </div>

                                    {
                                        rowSelectCount == 0?
                                            <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto', gap: '0 10px'}}>
                                                <Input id={'table-view-search'} prefix={<IconSearchPdfCard/>}
                                                       suffix={renderSuffix()}
                                                       variant={"borderless"}
                                                       className={'input-border'}
                                                       style={{
                                                           width: `${SEARCH_WIDTH}px`,
                                                           height: '32px',
                                                           flexShrink: '0',
                                                           fontSize:'12px',
                                                           fontFamily:'Poppins'
                                                           // backgroundColor: 'var(--input-background-color)'
                                                       }}
                                                       placeholder={t('Search')} value={searchKey}
                                                       onChange={(event) => {
                                                           mSearchKey.current = event.currentTarget.value;
                                                           setSearchKey(mSearchKey.current);
                                                           setIsSearching(true);

                                                           //清除上一次的计时
                                                           clearTimeout(mLastSearchTimeoutIdRef.current);
                                                           mLastSearchTimeoutIdRef.current = setTimeout(() => {
                                                               if (selectView.type == 'tableView'){
                                                                   tableViewRef.current?.doSearch(mSearchKey.current?.toLowerCase());
                                                                   setIsSearching(false);
                                                               }else{
                                                                   mszSearchKey = mSearchKey.current;
                                                                   refreshData();
                                                               }

                                                               clearTimeout(mLastSearchTimeoutIdRef.current);
                                                           }, 1500);
                                                       }}/>

                                                <Popover arrow={false} trigger={['click']} open={isFilterOpen} placement={'bottom'}
                                                         onOpenChange={(e) => {
                                                             if (selectView.type == 'gridView'){
                                                                 setIsFilterOpen(false);
                                                                 message.destroy();
                                                                 message.error(t('OnlyAvailableInTableView'));
                                                                 return;
                                                             }
                                                             //取
                                                             getPropertyList().then((res)=>{
                                                                 mPropertyListRef.current = res;
                                                             })
                                                             handleFilterChanged(e);
                                                         }}
                                                         align={{offset:[-16,0]}}
                                                         overlayInnerStyle={{
                                                             width: '460px',
                                                             maxHeight: `${document.body.offsetHeight * 0.5}px`,
                                                             padding: '12px 12px 12px 16px',
                                                             overflow: 'auto'
                                                         }} content={renderFilter()}>
                                                    <div className={'flex-row-vertical-center button-border-gray-style'}
                                                         style={{padding: '0 10px', flexShrink: '0'}}>
                                                        <img className={'img-12 '}
                                                             src={filterCount == 0 ? getImagePathWithThemeSvg('tag_view_filter') : getImagePathSvg('tag_view_filter_blue')}/>
                                                        <span className={'ml-4'}
                                                              style={{color: filterCount == 0 ? 'var(--text-color)' : 'var(--primary-color)'}}>{t('Filter') + `${filterCount == 0 ? '' : `(${filterCount})`}`}</span>
                                                    </div>
                                                </Popover>


                                                <Popover arrow={false} trigger={['click']}
                                                         open={isAddPropertyOpen}
                                                         onOpenChange={(e) => {
                                                             setIsAddPropertyOpen(e);
                                                             if (selectView.type == 'gridView'){
                                                                 setIsAddPropertyOpen(false);
                                                                 message.destroy();
                                                                 message.error(t('OnlyAvailableInTableView'));
                                                                 return;
                                                             }
                                                         }}
                                                         align={{offset:[-16,0]}}
                                                         overlayInnerStyle={{minWidth: '260px',maxWidth:'260px', padding: '12px 0px'}}
                                                         content={renderPropertyList()}>
                                                    <Tooltip arrow={false} title={t("Add properties")}>
                                                        <div className={'flex-row-vertical-center button-border-gray-style'}
                                                             style={{padding: '0 10px', flexShrink: '0'}}>
                                                            <img className={'img-12'}
                                                                 src={getImagePathWithTheme('add_property_icon.svg')}/>
                                                            <span className={'ml-4'}>{t('Properties')}</span>
                                                        </div>
                                                    </Tooltip>

                                                </Popover>

                                                {
                                                    <Dropdown overlayClassName='default-dropdown-style'
                                                              overlayStyle={{minWidth: '232px'}}
                                                              menu={{items: ARRAY_PROPERTY_ADD_ITEM()}} trigger={['click']}>
                                                        <div className={'flex-center button-solid-style'}
                                                             style={{padding: '0 10px', flexShrink: '0',minWidth:'70px',height:'32px'}}>
                                                            <img className={'img-12'} src={getImagePathSvg('add_white')}/>
                                                            <span className={'ml-4'}>{t('New')}</span>
                                                        </div>
                                                    </Dropdown>
                                                }

                                            </div>: <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>
                                                <Select style={{minWidth: '184px'}}
                                                        virtual={false}
                                                        options={selectView.columns.filter(p=>p.id != 'name' && p.id != 'type' && p.id != 'project' && p.id != 'createTime' && p.id != 'updateTime')}
                                                        dropdownStyle={{minWidth: '168px'}}
                                                        dropdownClassName={'shadow fix-gab-select-custom-option-render'}
                                                        value={t('Change properties')}
                                                        suffixIcon={<IconDropdownSelected/>} optionRender={(option)=>{
                                                    return<div className={'flex-row-vertical-center'} style={{width:'100%',height:'100%'}} onClick={(e)=>{
                                                        if (option.data.type == 'tags'){
                                                            window.showManageTags(tableViewRef.current?.onGetSelectItems());
                                                        }else{
                                                            dialogBatchUpdatePropertyRef.current?.onShowDialog(option.data,(szType,value)=>{
                                                                //更新所有选中的
                                                                tableViewRef.current?.onUpdateSelectValue(option.data,value);
                                                            });
                                                        }
                                                    }}>
                                                        <img className={'img-14'} src={getImagePathWithThemeSvg(option.data.icon)}/>
                                                        <span className={'ml-8'}>{t(option.data.name)}</span>
                                                    </div>
                                                }}/>
                                                <div style={{minWidth: '80px', marginLeft: '16px', height: '32px'}} onClick={() => {
                                                    window.showMessageBox(t("Tips"), t("ConfirmDeleteLibraryItems"), t("Cancel"), t("Delete"), null, () => {
                                                        tableViewRef.current?.onDeleteSelect();
                                                    })
                                                }}
                                                     className={'button-border-danger-style flex-center'}>{t("Delete")}</div>
                                            </div>
                                    }

                                </div>
                        }

                    </div>

                    {
                        false &&
                        <div className={'button-border-gray-style flex-center ml-16'}
                             style={{
                                 minWidth: operButtonName == t("Select") ? '56px' : '106px',
                                 height: '32px',
                                 fontSize: '13px',
                                 opacity: operButtonName == t("Cancel") ? '1' : '0',
                                 border: operButtonName == t("Select") ? '0px solid var(--button-no-fill-border-color)' : '1px solid var(--button-no-fill-border-color)'
                             }} onClick={() => {
                            if (operButtonName == t("Select")) {
                                //当前是选择状态，点击取消
                                setOperButtonName(t("Cancel"));
                            } else {
                                onCancelSelect();
                            }
                            setIsShowChecked(!isShowChecked);
                        }}>
                            {operButtonName}
                        </div>
                    }

                    <div style={{flexGrow: '1'}}></div>

                    {
                        operButtonName == t("Cancel") &&
                        <>
                            <Select style={{minWidth: '134px'}}
                                    virtual={false}
                                    dropdownStyle={{minWidth: '168px'}}
                                    dropdownClassName={'shadow'}
                                    value={exportValue} options={ARRAY_CARD_EXPORT}
                                    onChange={async (value, option) => {
                                        if (option.value == 'exportPdf') {
                                            const arraySelect = getSelectedArray();
                                            if (arraySelect.length == 0) {
                                                message.info(t("Please select"));
                                                return;
                                            }
                                            const isOk = await ipcInvoke('save-pdf-zip-to-system', JSON.stringify(arraySelect));
                                            if (isOk){
                                                window.showProgress('Exporting');
                                            }
                                        } else if (option.value == 'exportMarkdown') {
                                            exportMarkdown();
                                        }
                                    }}
                                    suffixIcon={<IconDropdownSelected/>}/>

                            <div style={{minWidth: '130px', height: '32px', marginLeft: '16px',}} onClick={() => {
                                addToProjectEvent();
                            }}
                                 className={'button-border-gray-style flex-center'}>{t("Add to project")}</div>

                            <div className={'button-border-gray-style flex-center ml-16'} onClick={() => {
                                const arraySelected = arrayDatas.filter(p => p.isChecked);
                                if (arraySelected.length == 0) {
                                    message.info('PleaseSelected');
                                    return;
                                }
                                mMapIdCheck = {};
                                arraySelected.forEach(p => {
                                    mMapIdCheck[p.id] = true;
                                })
                                dialogTagManagerRef.current?.onShowDialog(arraySelected);
                            }} style={{minWidth: '132px', height: '32px'}}>
                                {t("Manage tags")}
                            </div>

                            <div style={{minWidth: '80px', marginLeft: '16px', height: '32px'}} onClick={() => {
                                //删除选择的.
                                onDeleteChecked()
                            }}
                                 className={'button-border-danger-style flex-center'}>{t("Delete")}</div>
                        </>
                    }

                    {
                        // !isShowChecked &&
                        // <Dropdown overlayClassName='default-dropdown-style' overlayStyle={{minWidth: '232px'}}
                        //           menu={{items: sortMenu, onClick: onSortMenuClick}} trigger={['click']}
                        //           onOpenChange={handleSortOpenChange} open={sortMenuOpen}>
                        //       <span className='hovered' style={{flexShrink:'0'}} onClick={(e) => e.preventDefault()}>
                        //           <div className='flex-row-vertical-center'
                        //                style={{height: '28px', padding: '0px 8px', marginLeft: 'auto',}}>
                        //               <span className='text-color'>{sortTypeDesc}</span>
                        //               <img className='img-mini-small ml-6' style={{width: '10px', height: '10px'}}
                        //                    src={getImagePathWithTheme("library_dropdown")}/>
                        //           </div>
                        //       </span>
                        // </Dropdown>
                    }


                </div>
                <div ref={divContainerRef} id={'divCardItemContainer-tagitem-list'} style={{width:'calc(100% + 40px)',height:isMac()?'100%':`calc(100% - ${TITLE_BAR_HEIGHT}px)`,margin:'0 -20px',padding:'0 12px'}}>
                    {
                        !selectView ? <></> :
                            selectView?.type == 'gridView' ?
                                renderNoteList() : renderTableview()
                    }
                </div>


                <DialogTagManager ref={dialogTagManagerRef} from={"library"} onDismissCallback={(isTagChange: boolean) => {
                    //标签更改了，需要刷新数据....
                    refreshData();
                }}/>

                <DialogMessageBox ref={dialogMessageRef}/>

                <DialogCommonInput ref={dialogCommonInputRef}/>

                <DialogCommonInput ref={dialogCommonInputRef}/>

                <DialogChooseThumb ref={dialogChooseThumbRef}/>

                <DialogBatchUpdateProperty ref={dialogBatchUpdatePropertyRef} onCloseCallback={()=>{

                }}/>
            </>
        )
    }

    return renderTagItemList()
})

export default TagItemList;


















